export const productByShop = {
	"product": [{
		"categories": ["fashion"],
		"productType": "general",
		"description": [{
			"contentType": "text",
			"content": "<p><strong>โลชั่นกันแดดสำหรับกีฬาทุกชนิด หรือกิจกรรม Outdoor</strong> ช่วยปกป้องผิวจากการเผาไหม้ของแสงแดดได้มากกว่า 50 เท่า <strong>พร้อมปกป้องทั้งรังสียูวีเอและยูวีบี </strong>กันแดดได้ยาวนาน <strong><u>กันน้ำกันเหงื่อได้ดีเยี่ยม</u></strong></p>"
		}],
		"nameEn": null,
		"advancePay": null,
		"imagePathIds": [683],
		"videoPathIds": [],
		"tags": [],
		"seo": {
			"title": "โลชั่นกันแดด Sport Sunscreen Lotion พร้อมพาผิวสวยๆ ลุยได้ทุกที่",
			"description": "โลชั่นกันแดดสำหรับกีฬาทุกชนิด หรือกิจกรรม Outdoor ช่วยปกป้องผิวจากการเผาไหม้ของแสงแดดได้มากกว่า 50 เท่า พร้อมปกป้องทั้งรังสียูวีเอและยูวีบี กันแดดได้ยาวนาน กันน้ำกันเหงื่อได้ดีเยี่ยม",
			"keyword": ["Banana Boat", "โลชั่นกันแดด", "กันแดดกันน้ำกันเหงื่อ", "SPF 50+ PA+++"],
			"seoImage": {
				"type": "image",
				"path": "image/a9b96935-0723-485d-8847-6b2753db6609.jpg",
				"id": 684
			},
			"seoLength": {
				"title": "bad",
				"description": "bad",
				"keyword": "bad"
			},
			"permalink": "sport-sunscreen-lotion-spf-50+-pa+++",
			"seoImageId": 684
		},
		"unitType": "ชิ้น",
		"solds": 40,
		"remains": 959,
		"reserve": 1,
		"specifications": [],
		"skus": 1,
		"ribbon": [],
		"status": "show",
		"brand": "Banana Boat",
		"showOn": ["live", "shelf"],
		"platforms": ["callcenter", "web", "application"],
		"deleted": 0,
		"seoUpdatedAt": "2021-02-19T10:18:06.000Z",
		"freeShipping": 0,
		"conditionType": "new",
		"deliveryRules": 72,
		"prepareDay": 24,
		"shopId": 7,
		"saleType": "buynow",
		"name": "🌞 Banana Boat Sport Sunscreen Lotion SPF 50+ PA+++",
		"coverPathId": 683,
		"createdBy": 50,
		"id": 32,
		"createdAt": "2020-11-28T10:10:14.341Z",
		"updatedAt": "2021-02-19T10:18:07.239Z",
		"__v": 0,
		"productCode": "32",
		"videoPath": [],
		"coverPath": {
			"type": "image",
			"path": "image/eeb235e6-8efa-4858-91ca-b84824f0e317.jpg",
			"id": 683
		},
		"imagePath": [{
			"type": "image",
			"path": "image/eeb235e6-8efa-4858-91ca-b84824f0e317.jpg",
			"id": 683
		}],
		"shop": {
			"logoPathId": 1410,
			"coverPathId": 1485,
			"imagePathIds": [],
			"videoPathIds": [],
			"name": "Banana Boat",
			"id": 7,
			"imagePath": [],
			"videoPath": [],
			"shopHub": {
				"address1": "467/11 โครงการมหาทุนพระราม 3",
				"address2": null,
				"location": {
					"lat": 13.689691,
					"lng": 100.512098
				},
				"primary": 0,
				"status": "show",
				"deleted": 0,
				"shopId": 7,
				"name": "Banana Boat",
				"mobile": "026891560",
				"subdistrict": "บางโคล่",
				"district": "บางคอแหลม",
				"province": "กรุงเทพมหานคร",
				"zipcode": "10120",
				"id": 6,
				"createdAt": "2020-11-27T08:45:22.262Z",
				"updatedAt": "2021-01-06T05:31:35.066Z",
				"__v": 0
			},
			"logoPath": {
				"type": "image",
				"path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
				"id": 1410
			},
			"coverPath": {
				"type": "image",
				"path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
				"id": 1485
			}
		},
		"productSkus": [{
			"productId": 32,
			"imagePathId": 685,
			"priceList": 535,
			"priceNet": 267,
			"priceCost": 214,
			"stockRemain": 959,
			"status": "show",
			"statusStock": "instock",
			"showOn": ["shelf", "live"],
			"sku": "32-90 ml",
			"id": 91,
			"imagePath": {
				"type": "image",
				"path": "image/103462cc-ca44-4bf6-80bc-cb7e88177582.jpg",
				"id": 685
			},
			"productDiscount": [],
			"attributeSKU": "90 ml"
		}],
		"priceNet": 267,
		"priceTotal": 535
	}, {
		"categories": ["fashion"],
		"productType": "general",
		"description": [{
			"contentType": "text",
			"content": "<p>โลชั่นกันแดดสำหรับปกป้องผิวทุกวันเนื้อครีมบางเบาไม่เหนียวเหนอะหนะ ซึมซาบเร็วไม่อุดตันรูขุมขน<strong>มีส่วนผสมของว่านหางจระเข้ วิตามินซีและอี ช่วยให้ผิวเนียนนุ่มชุ่มชื้น</strong> พร้อมช่วยปกป้องผิวจากการเผาไหม้ของแสงแดดถึง 50 เท่า พร้อมปกป้องทั้งรังสียูวีเอและยูวีบี ซึ่งเป็นสาเหตุของริ้วรอยและมะเร็งผิวหนัง กันแดดได้ยาวนาน กันน้ำได้ดีเยี่ยมมีกลิ่นหอมธรรมชาติ</p>"
		}],
		"nameEn": null,
		"advancePay": null,
		"imagePathIds": [213],
		"videoPathIds": [],
		"tags": [],
		"seo": {
			"title": "ริ้วรอยกระเด็น!  กันแดดยาวนาน ด้วย Ultra Protect Sunscreen Lotion",
			"description": "Ultra Protect Sunscreen Lotion SPF 50 PA+++ โลชั่นกันแดด พร้อมส่วนผสมของว่านหางจระเข้ วิตามินซีและอี ช่วยให้ผิวเนียนนุ่มชุ่มชื้นช่วยให้ผิวเนียนนุ่มชุ่มชื่น ช่วยปกป้องผิวจากการเผาไหม้ของแสงแดดถึง 50 เท่า ทั้งรังสี UVA และ UVB",
			"keyword": ["โลชั่นกันแดด", " Banana Boat", "กันแดดบำรุงผิว ", "กันแดดครีมซึมไว", "กันแดดกันน้ำ", "SPF 50 PA+++"],
			"seoImage": {
				"type": "image",
				"path": "image/9687b777-6198-4f73-8e52-5fe3285d0459.jpg",
				"id": 214
			},
			"seoLength": {
				"title": "bad",
				"description": "bad",
				"keyword": "good"
			},
			"permalink": "ultra-protect-sunscreen-lotion-spf-50-pa+++",
			"seoImageId": 214
		},
		"unitType": "ชิ้น",
		"solds": 5,
		"remains": 994,
		"reserve": 1,
		"specifications": [],
		"skus": 1,
		"ribbon": [],
		"status": "show",
		"brand": "Banana Boat",
		"showOn": ["live", "shelf", "normal"],
		"platforms": ["callcenter", "web", "application"],
		"deleted": 0,
		"seoUpdatedAt": "2021-02-19T09:40:33.000Z",
		"freeShipping": 0,
		"conditionType": "new",
		"deliveryRules": 72,
		"prepareDay": 24,
		"shopId": 7,
		"saleType": "buynow",
		"name": "🌞 Banana Boat Ultra Protect Sunscreen Lotion SPF 50 PA",
		"coverPathId": 213,
		"createdBy": 50,
		"id": 33,
		"createdAt": "2020-11-28T10:26:20.647Z",
		"updatedAt": "2021-02-19T09:40:34.024Z",
		"__v": 0,
		"productCode": "33",
		"videoPath": [],
		"coverPath": {
			"type": "image",
			"path": "image/3ba27607-199f-4b5e-a683-ab5f2615a8cc.jpg",
			"id": 213
		},
		"imagePath": [{
			"type": "image",
			"path": "image/3ba27607-199f-4b5e-a683-ab5f2615a8cc.jpg",
			"id": 213
		}],
		"shop": {
			"logoPathId": 1410,
			"coverPathId": 1485,
			"imagePathIds": [],
			"videoPathIds": [],
			"name": "Banana Boat",
			"id": 7,
			"imagePath": [],
			"videoPath": [],
			"shopHub": {
				"address1": "467/11 โครงการมหาทุนพระราม 3",
				"address2": null,
				"location": {
					"lat": 13.689691,
					"lng": 100.512098
				},
				"primary": 0,
				"status": "show",
				"deleted": 0,
				"shopId": 7,
				"name": "Banana Boat",
				"mobile": "026891560",
				"subdistrict": "บางโคล่",
				"district": "บางคอแหลม",
				"province": "กรุงเทพมหานคร",
				"zipcode": "10120",
				"id": 6,
				"createdAt": "2020-11-27T08:45:22.262Z",
				"updatedAt": "2021-01-06T05:31:35.066Z",
				"__v": 0
			},
			"logoPath": {
				"type": "image",
				"path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
				"id": 1410
			},
			"coverPath": {
				"type": "image",
				"path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
				"id": 1485
			}
		},
		"productSkus": [{
			"productId": 33,
			"imagePathId": 215,
			"priceList": 435,
			"priceNet": 217,
			"priceCost": 174,
			"stockRemain": 994,
			"status": "show",
			"statusStock": "instock",
			"showOn": ["normal", "shelf", "live"],
			"sku": "33-90 ml",
			"id": 92,
			"imagePath": {
				"type": "image",
				"path": "image/69f84092-ad20-472f-98f7-68a5e1ad555a.jpg",
				"id": 215
			},
			"productDiscount": [],
			"attributeSKU": "90 ml"
		}],
		"priceNet": 217,
		"priceTotal": 435
	}, {
		"categories": ["health&beauty"],
		"productType": "general",
		"description": [{
			"contentType": "text",
			"content": "<p>โลชั่นปกป้องแสงแดดสูตร<strong>เนื้อครีมบางเบา</strong>สามารถทำกิจกรรมท่ามกลางแสงแดดได้ยาวนานโดยปราศจากความเหนียวเหนอะหนะด้วยสูตรเฉพาะของบานาน่าโบ๊ทเนื้อโลชั่นสามารถปกป้องรังสี UVA/UVB ได้อย่างมีประสิทธิภาพ เนื้อโลชั่นซึมซาบเร็วไม่อุดตันรูขุมขนทำให้รู้สึกสบายผิวขณะใช้และสามารถบำรุงผิวกายให้กลับมาดูกระจ่างใสมีชีวิตชีวาอีกครั้งหลังออกแดด</p>"
		}],
		"nameEn": null,
		"advancePay": null,
		"imagePathIds": [702],
		"videoPathIds": [],
		"tags": [],
		"seo": {
			"title": "Dry Balance Sunscreen Lotion เนื้อบางเบา ไม่เหนอะ พร้อมบำรุงผิว",
			"description": "เนื้อโลชั่นซึมซาบเร็วไม่อุดตันรูขุมขนทำให้รู้สึกสบายผิวขณะใช้และสามารถบำรุงผิวกายให้กลับมาดูกระจ่างใสมีชีวิตชีวาอีกครั้งหลังออกแดด ด้วยสูตรเฉพาะของบานาน่าโบ๊ทเนื้อโลชั่นสามารถปกป้องรังสี UVA/UVB ",
			"keyword": ["โลชั่นกันแดด", " Banana Boat", " SPF50+  PA++++", "กันแดด ปกป้องรังสี UVA/UVB", "กันแดดสูตรบำรุงผิว "],
			"seoImage": {
				"type": "image",
				"path": "image/b157f131-0620-4358-a017-68086bf924a7.jpg",
				"id": 707
			},
			"seoLength": {
				"title": "bad",
				"description": "bad",
				"keyword": "good"
			},
			"permalink": "dry-balance-sunscreen-lotion-spf-50+-pa+++",
			"seoImageId": 707
		},
		"unitType": "ชิ้น",
		"solds": 51,
		"remains": 977,
		"reserve": -28,
		"specifications": [],
		"skus": 1,
		"ribbon": [],
		"status": "show",
		"brand": "Banana Boat",
		"showOn": ["live", "shelf"],
		"platforms": ["callcenter", "web", "application"],
		"deleted": 0,
		"seoUpdatedAt": "2021-01-20T08:59:09.000Z",
		"freeShipping": 0,
		"conditionType": "new",
		"deliveryRules": 72,
		"prepareDay": 24,
		"shopId": 7,
		"saleType": "buynow",
		"name": "🌞 Banana Boat Dry Balance Sunscreen Lotion SPF 50+ PA+++",
		"coverPathId": 702,
		"createdBy": 50,
		"id": 34,
		"createdAt": "2020-11-28T10:40:20.803Z",
		"updatedAt": "2021-02-18T11:50:06.186Z",
		"__v": 0,
		"productCode": "34",
		"videoPath": [],
		"coverPath": {
			"type": "image",
			"path": "image/661da8f0-ace1-49fc-814b-816994ffae1a.jpg",
			"id": 702
		},
		"imagePath": [{
			"type": "image",
			"path": "image/661da8f0-ace1-49fc-814b-816994ffae1a.jpg",
			"id": 702
		}],
		"shop": {
			"logoPathId": 1410,
			"coverPathId": 1485,
			"imagePathIds": [],
			"videoPathIds": [],
			"name": "Banana Boat",
			"id": 7,
			"imagePath": [],
			"videoPath": [],
			"shopHub": {
				"address1": "467/11 โครงการมหาทุนพระราม 3",
				"address2": null,
				"location": {
					"lat": 13.689691,
					"lng": 100.512098
				},
				"primary": 0,
				"status": "show",
				"deleted": 0,
				"shopId": 7,
				"name": "Banana Boat",
				"mobile": "026891560",
				"subdistrict": "บางโคล่",
				"district": "บางคอแหลม",
				"province": "กรุงเทพมหานคร",
				"zipcode": "10120",
				"id": 6,
				"createdAt": "2020-11-27T08:45:22.262Z",
				"updatedAt": "2021-01-06T05:31:35.066Z",
				"__v": 0
			},
			"logoPath": {
				"type": "image",
				"path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
				"id": 1410
			},
			"coverPath": {
				"type": "image",
				"path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
				"id": 1485
			}
		},
		"productSkus": [{
			"productId": 34,
			"imagePathId": 709,
			"priceList": 480,
			"priceNet": 240,
			"priceCost": 192,
			"stockRemain": 977,
			"status": "show",
			"statusStock": "instock",
			"showOn": ["shelf", "live"],
			"sku": "34-90 ml",
			"id": 93,
			"imagePath": {
				"type": "image",
				"path": "image/003a8f72-281e-40cc-899f-bcaa8ffa3e4e.jpg",
				"id": 709
			},
			"productDiscount": [],
			"attributeSKU": "90 ml"
		}],
		"priceNet": 240,
		"priceTotal": 480
	}, {
		"categories": ["health&beauty"],
		"productType": "general",
		"description": [{
			"contentType": "text",
			"content": "<p>โลชั่นปกป้องแสงแดด เป็นสูตร Provides broad spectrum UVA /UVB มากกว่า 50 เท่า<strong><u>โดยลดปริมาณสารเคมีลงถึง 25% </u></strong>ด้วยสูตรอ่อนโยนและบอบบางที่สุด <strong>ไม่มีส่วนผสม Oxybenzone &amp; Parabens ,&nbsp;Alcohol &amp; Oil, Microplsatic </strong>เนื้อโลชั่นเบาดุจน้ำสบายผิวไม่มันวาว , ทาผิวได้อย่างราบรื่น , เหมาะสำหรับผิวหน้าและผิวกาย , มีกลิ่นหอมประดุจดอกไม้ , <strong>มีส่วนผสมของ Hyaluronic Acid</strong></p>"
		}],
		"nameEn": null,
		"advancePay": null,
		"imagePathIds": [717],
		"videoPathIds": [],
		"tags": [],
		"seo": {
			"title": "กันแดดสูตรอ่อนโยน ดีต่อผิวหน้าและผิวกาย โนหน้าไม่มันวาว ไม่มีซับ ",
			"description": "โลชั่นปกป้องแสงแดด เป็นสูตร Provides broad spectrum UVA /UVB มากกว่า 50 เท่าโดยลดปริมาณสารเคมีลงถึง 25% ด้วยสูตรอ่อนโยนและบอบบางที่สุด ไม่มีส่วนผสม Oxybenzone & Parabens ,  Alcohol & Oil, Microplsatic มีส่วนผสมของ Hyaluronic Acid ",
			"keyword": ["โลชั่นกันแดด", "Banana Boat", " SPF50+ PA++++", " กันแดดสูตรอ่อนโยน ", "Hyaluronic Acid"],
			"seoImage": {
				"type": "image",
				"path": "image/dc90f672-457c-4081-a6cc-1359590e1c5e.jpg",
				"id": 718
			},
			"seoLength": {
				"title": "bad",
				"description": "bad",
				"keyword": "good"
			},
			"permalink": "simply-protect-aqua-daily-sunscreen-lotion-spf50+-pa++++",
			"seoImageId": 718
		},
		"unitType": "ชิ้น",
		"solds": 11,
		"remains": 989,
		"reserve": 0,
		"specifications": [],
		"skus": 1,
		"ribbon": [],
		"status": "show",
		"brand": "Banana Boat",
		"showOn": ["live", "shelf"],
		"platforms": ["callcenter", "web", "application"],
		"deleted": 0,
		"seoUpdatedAt": "2021-02-03T11:36:32.000Z",
		"freeShipping": 0,
		"conditionType": "new",
		"deliveryRules": 72,
		"prepareDay": 24,
		"shopId": 7,
		"saleType": "buynow",
		"name": "Banana Boat Simply Protect Aqua Daily Sunscreen Lotion SPF50+ PA++++ 50 ml. / บานาน่า โบ้ท ซิมพลี่ โพรเทค อควา เดลี่ ซันสกรีน เอสพีเอฟ50+ พีเอ++++ 50 มล. สูตรอ่อนโยน ดีต่อผิวหน้าและผิวกาย โนหน้าไม่มันวาว ไม่มีซับ",
		"coverPathId": 717,
		"createdBy": 50,
		"id": 35,
		"createdAt": "2020-11-28T10:53:55.780Z",
		"updatedAt": "2021-02-19T03:20:31.232Z",
		"__v": 0,
		"productCode": "35",
		"videoPath": [],
		"coverPath": {
			"type": "image",
			"path": "image/1555a330-d39f-4001-9acf-f2f949679c0f.jpg",
			"id": 717
		},
		"imagePath": [{
			"type": "image",
			"path": "image/1555a330-d39f-4001-9acf-f2f949679c0f.jpg",
			"id": 717
		}],
		"shop": {
			"logoPathId": 1410,
			"coverPathId": 1485,
			"imagePathIds": [],
			"videoPathIds": [],
			"name": "Banana Boat",
			"id": 7,
			"imagePath": [],
			"videoPath": [],
			"shopHub": {
				"address1": "467/11 โครงการมหาทุนพระราม 3",
				"address2": null,
				"location": {
					"lat": 13.689691,
					"lng": 100.512098
				},
				"primary": 0,
				"status": "show",
				"deleted": 0,
				"shopId": 7,
				"name": "Banana Boat",
				"mobile": "026891560",
				"subdistrict": "บางโคล่",
				"district": "บางคอแหลม",
				"province": "กรุงเทพมหานคร",
				"zipcode": "10120",
				"id": 6,
				"createdAt": "2020-11-27T08:45:22.262Z",
				"updatedAt": "2021-01-06T05:31:35.066Z",
				"__v": 0
			},
			"logoPath": {
				"type": "image",
				"path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
				"id": 1410
			},
			"coverPath": {
				"type": "image",
				"path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
				"id": 1485
			}
		},
		"productSkus": [{
			"productId": 35,
			"imagePathId": 719,
			"priceList": 390,
			"priceNet": 195,
			"priceCost": 156,
			"stockRemain": 989,
			"status": "show",
			"statusStock": "instock",
			"showOn": ["shelf", "live"],
			"sku": "35-50 ml",
			"id": 94,
			"imagePath": {
				"type": "image",
				"path": "image/81357635-7455-43af-a8a0-8983ff579068.jpg",
				"id": 719
			},
			"productDiscount": [],
			"attributeSKU": "50 ml"
		}],
		"priceNet": 195,
		"priceTotal": 390
	}, {
		"categories": ["health&beauty"],
		"productType": "general",
		"description": [{
			"contentType": "text",
			"content": "<p>โลชั่นปกป้องแสงแดด เป็นสูตร Provides broad spectrum UVA /UVB มากกว่า 50 เท่าโดย <strong><u>ลดปริมาณสารเคมีลงถึง 25%</u></strong> ด้วยสูตรอ่อนโยนและบอบบางที่สุด <strong>ไม่มีส่วนผสม Oxybenzone &amp; Parabens ,&nbsp;Alcohol &amp; Oil กันน้ำกันเหงื่อ,</strong> เหมาะสำหรับผิวหน้าและผิวกาย , <strong>ปกป้องสำหรับกีฬาและกิจกรรมกลางแจ้ง</strong> , มีกลิ่นหอมอ่อนๆ มีส่วนผสมของ Hyaluronic Acid</p>"
		}],
		"nameEn": null,
		"advancePay": null,
		"imagePathIds": [725],
		"videoPathIds": [],
		"tags": [],
		"seo": {
			"title": "โลชั่นกันแดดสูตรอ่อนโยน  กัน UVA /UVB มากกว่า 50 เท่า ",
			"description": "Simply Aqua Long Wearing Sunscreen Lotion SPF 50+ PA++++ โลชั่นปกป้องแสงแดด เป็นสูตร Provides broad spectrum UVA /UVB มากกว่า 50 เท่า โดยลดปริมาณสารเคมีลงถึง 25% ด้วยสูตรอ่อนโยนและบอบบางที่สุด",
			"keyword": ["โลชั่นกันแดด", "Banana Boat", "กันแดดผิวแพ้ง่าย", " UVA /UVB มากกว่า 50 เท่า", "SPF 50+ PA++++ "],
			"seoImage": {
				"type": "image",
				"path": "image/36a52f3e-2199-44b5-a7ae-1d1ec0843dd4.jpg",
				"id": 726
			},
			"seoLength": {
				"title": "bad",
				"description": "bad",
				"keyword": "good"
			},
			"permalink": "simply-aqua-long-wearing-sunscreen-lotion-spf-50+-pa++++",
			"seoImageId": 726
		},
		"unitType": "ชิ้น",
		"solds": 44,
		"remains": 959,
		"reserve": -3,
		"specifications": [],
		"skus": 1,
		"ribbon": [],
		"status": "show",
		"brand": "Banana Boat",
		"showOn": ["normal", "shelf", "live"],
		"platforms": ["callcenter", "web", "application"],
		"deleted": 0,
		"seoUpdatedAt": "2020-12-16T10:54:04.000Z",
		"freeShipping": 0,
		"conditionType": "new",
		"deliveryRules": 72,
		"prepareDay": 24,
		"shopId": 7,
		"saleType": "buynow",
		"name": "🌞 Banana Boat Simply Aqua Long Wearing Sunscreen Lotion SPF 50+ PA++++",
		"coverPathId": 725,
		"createdBy": 50,
		"id": 36,
		"createdAt": "2020-11-28T11:10:17.931Z",
		"updatedAt": "2021-02-18T11:49:50.883Z",
		"__v": 0,
		"productCode": "36",
		"videoPath": [],
		"coverPath": {
			"type": "image",
			"path": "image/e8ebdd91-f7bc-4cf5-a1f2-df63b6632762.jpg",
			"id": 725
		},
		"imagePath": [{
			"type": "image",
			"path": "image/e8ebdd91-f7bc-4cf5-a1f2-df63b6632762.jpg",
			"id": 725
		}],
		"shop": {
			"logoPathId": 1410,
			"coverPathId": 1485,
			"imagePathIds": [],
			"videoPathIds": [],
			"name": "Banana Boat",
			"id": 7,
			"imagePath": [],
			"videoPath": [],
			"shopHub": {
				"address1": "467/11 โครงการมหาทุนพระราม 3",
				"address2": null,
				"location": {
					"lat": 13.689691,
					"lng": 100.512098
				},
				"primary": 0,
				"status": "show",
				"deleted": 0,
				"shopId": 7,
				"name": "Banana Boat",
				"mobile": "026891560",
				"subdistrict": "บางโคล่",
				"district": "บางคอแหลม",
				"province": "กรุงเทพมหานคร",
				"zipcode": "10120",
				"id": 6,
				"createdAt": "2020-11-27T08:45:22.262Z",
				"updatedAt": "2021-01-06T05:31:35.066Z",
				"__v": 0
			},
			"logoPath": {
				"type": "image",
				"path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
				"id": 1410
			},
			"coverPath": {
				"type": "image",
				"path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
				"id": 1485
			}
		},
		"productSkus": [{
			"productId": 36,
			"imagePathId": 727,
			"priceList": 390,
			"priceNet": 195,
			"priceCost": 156,
			"stockRemain": 959,
			"status": "show",
			"statusStock": "instock",
			"showOn": ["normal", "shelf", "live"],
			"sku": "36-50 ml",
			"id": 95,
			"imagePath": {
				"type": "image",
				"path": "image/3d62c79d-5052-4026-b29e-fedb284a4560.jpg",
				"id": 727
			},
			"productDiscount": [],
			"attributeSKU": "50 ml"
		}],
		"priceNet": 195,
		"priceTotal": 390
	}, {
		"categories": ["health&beauty"],
		"productType": "general",
		"description": [{
			"contentType": "text",
			"content": "<p>- <strong>ผลิตภัณฑ์เจลบำรุงผิว (แบบขวด</strong>) ช่วยบำรุงผิวให้เนียนนุ่มชุ่มชื้น และยังช่วย<strong>บรรเทาอาการผิวไหม้จากแสงแดด</strong> สำหรับผู้ที่ตากแดดเป็นเวลานาน <strong>อุดมไปด้วยสารสกัดจากว่านหางจระเข้ </strong>ทำให้ผิวรู้สึกเย็นสบายเรียบเนียนยิ่งขึ้น</p><p><br></p><p><strong>- ผลิตภัณฑ์เจลบำรุงผิว (แบบหลอด)</strong> ช่วยบำรุงผิวให้เนียนนุ่มชุ่มชื้น และยังช่วย<strong>บรรเทาอาการผิวไหม้จากแสงแดด </strong>สำหรับผู้ที่ตากแดดเป็นเวลานาน <strong>อุดมไปด้วยสารสกัดจากว่านหางจระเข้ </strong>ทำให้ผิวรู้สึกเย็นสบายเรียบเนียนยิ่งขึ้น</p>"
		}],
		"nameEn": null,
		"advancePay": null,
		"imagePathIds": [732, 733],
		"videoPathIds": [],
		"tags": [],
		"seo": {
			"title": "ผิวไหม้ จากแสงแดด  Aloe Vera Gel ช่วยคุณได้ ผิว Happy ไม่มีเศร้า",
			"description": "ผลิตภัณฑ์เจลบำรุงผิว (แบบขวด) ช่วยบำรุงผิวให้เนียนนุ่มชุ่มชื้น และยังช่วยบรรเทาอาการผิวไหม้จากแสงแดด สำหรับผู้ที่ตากแดดเป็นเวลานาน อุดมไปด้วยสารสกัดจากว่านหางจระเข้ ทำให้ผิวรู้สึกเย็นสบายเรียบเนียนยิ่งขึ้น ",
			"keyword": ["Banana Boat ", "Aloe Vera Gel", " ผิวไหม้จากแสงแดด ", "ผลิตภัณฑ์ว่านหางจระเข้"],
			"seoImage": {
				"type": "image",
				"path": "image/ed19dfd4-3c17-4de0-9dd7-249ce66e6b92.jpg",
				"id": 734
			},
			"seoLength": {
				"title": "bad",
				"description": "bad",
				"keyword": "bad"
			},
			"permalink": "aloe-vera-gel",
			"seoImageId": 734
		},
		"unitType": "ชิ้น",
		"solds": 38,
		"remains": 1962,
		"reserve": 0,
		"specifications": [],
		"skus": 1,
		"ribbon": [],
		"status": "show",
		"brand": "Banana Boat",
		"showOn": ["live", "shelf", "normal"],
		"platforms": ["callcenter", "web", "application"],
		"deleted": 0,
		"seoUpdatedAt": "2021-01-19T07:13:38.000Z",
		"freeShipping": 0,
		"conditionType": "new",
		"deliveryRules": 72,
		"prepareDay": 24,
		"shopId": 7,
		"saleType": "buynow",
		"name": "🌞 Banana Boat Aloe Vera Gel ",
		"coverPathId": 732,
		"createdBy": 50,
		"id": 37,
		"createdAt": "2020-11-28T11:19:53.590Z",
		"updatedAt": "2021-02-18T08:52:30.727Z",
		"__v": 0,
		"productCode": "37",
		"videoPath": [],
		"coverPath": {
			"type": "image",
			"path": "image/965ac02a-c5ef-43fd-a1fd-e1cc8be6cbbb.jpg",
			"id": 732
		},
		"imagePath": [{
			"type": "image",
			"path": "image/965ac02a-c5ef-43fd-a1fd-e1cc8be6cbbb.jpg",
			"id": 732
		}, {
			"type": "image",
			"path": "image/7757560c-5784-44ab-af6c-0003bf34ad34.jpg",
			"id": 733
		}],
		"shop": {
			"logoPathId": 1410,
			"coverPathId": 1485,
			"imagePathIds": [],
			"videoPathIds": [],
			"name": "Banana Boat",
			"id": 7,
			"imagePath": [],
			"videoPath": [],
			"shopHub": {
				"address1": "467/11 โครงการมหาทุนพระราม 3",
				"address2": null,
				"location": {
					"lat": 13.689691,
					"lng": 100.512098
				},
				"primary": 0,
				"status": "show",
				"deleted": 0,
				"shopId": 7,
				"name": "Banana Boat",
				"mobile": "026891560",
				"subdistrict": "บางโคล่",
				"district": "บางคอแหลม",
				"province": "กรุงเทพมหานคร",
				"zipcode": "10120",
				"id": 6,
				"createdAt": "2020-11-27T08:45:22.262Z",
				"updatedAt": "2021-01-06T05:31:35.066Z",
				"__v": 0
			},
			"logoPath": {
				"type": "image",
				"path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
				"id": 1410
			},
			"coverPath": {
				"type": "image",
				"path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
				"id": 1485
			}
		},
		"productSkus": [{
			"productId": 37,
			"imagePathId": 736,
			"priceList": 150,
			"priceNet": 75,
			"priceCost": 60,
			"stockRemain": 970,
			"status": "show",
			"statusStock": "instock",
			"showOn": ["normal", "shelf", "live"],
			"sku": "37-หลอด",
			"id": 191,
			"imagePath": {
				"type": "image",
				"path": "image/f60bd6a8-73ee-462d-865e-f74ca22ae2d4.jpg",
				"id": 736
			},
			"productDiscount": [],
			"attributeSKU": "หลอด"
		}, {
			"productId": 37,
			"imagePathId": 1134,
			"priceList": 340,
			"priceNet": 170,
			"priceCost": 136,
			"stockRemain": 992,
			"status": "show",
			"statusStock": "instock",
			"showOn": ["normal", "shelf", "live"],
			"sku": "37-ขวด",
			"id": 285,
			"imagePath": {
				"type": "image",
				"path": "image/e3bb7bb8-f60f-42d3-8857-66bfb87c89e2.jfif",
				"id": 1134
			},
			"productDiscount": [],
			"attributeSKU": "ขวด"
		}],
		"priceNet": 75,
		"priceTotal": 150
	}, {
		"categories": ["health&beauty"],
		"productType": "general",
		"description": [{
			"contentType": "text",
			"content": "<p>สเปรย์กันแดดสำหรับปกป้องผิวใช้ได้ทุกวันเนื้อสเปรย์ซึมซาบเร็วไม่อุดตันรูขุมขน มีส่วนผสมของว่านหางจระเข้และวิตามินอีช่วยให้ผิวเนียนนุ่มชุ่มชื้นเย็นสดชื่นสบายผิว <strong><u>พร้อมช่วยปกป้องผิวจากการเผาไหม้ของแสงแดดถึง 50 เท่า</u></strong> พร้อมปกป้องทั้งรังสียูวีเอและยูวีบีซึ่งเป็นสาเหตุของริ้วรอยและมะเร็งผิวหนัง กันแดดได้ยาวนานและกันน้ำได้ดีเยี่ยม</p>"
		}],
		"nameEn": null,
		"advancePay": null,
		"imagePathIds": [746],
		"videoPathIds": [],
		"tags": [],
		"seo": {
			"title": "สเปรย์กันแดด  พกสะดวกใช้ง่าย แค่ฉีด เอาแดดอยู่หมัด ",
			"description": "สเปรย์กันแดดสำหรับปกป้องผิวใช้ได้ทุกวันเนื้อสเปรย์ซึมซาบเร็วไม่อุดตันรูขุมขน มีส่วนผสมของว่านหางจระเข้และวิตามินอีช่วยให้ผิวเนียนนุ่มชุ่มชื้นเย็นสดชื่นสบายผิวพร้อมช่วยปกป้องผิวจากการเผาไหม้ของแสงแดดถึง 50 เท่า",
			"keyword": ["Banana Boat", "สเปรย์กันแดด", "สเปรย์กันแดดกันน้ำ"],
			"seoImage": {
				"type": "image",
				"path": "image/acaf531a-1114-4583-8fb3-97f0a0424095.jpg",
				"id": 747
			},
			"seoLength": {
				"title": "bad",
				"description": "bad",
				"keyword": "good"
			},
			"permalink": "ultramist-ultra-protect-sunscreen-lotion-spf-50-pa+++",
			"seoImageId": 747
		},
		"unitType": "ชิ้น",
		"solds": 36,
		"remains": 973,
		"reserve": -9,
		"specifications": [],
		"skus": 1,
		"ribbon": [],
		"status": "show",
		"brand": "Banana Boat",
		"showOn": ["normal", "shelf", "live"],
		"platforms": ["callcenter", "web", "application"],
		"deleted": 0,
		"seoUpdatedAt": "2020-12-21T07:55:42.000Z",
		"freeShipping": 0,
		"conditionType": "new",
		"deliveryRules": 72,
		"prepareDay": 24,
		"shopId": 7,
		"saleType": "buynow",
		"name": "🌞 Banana Boat UltraMist Ultra Protect Sunscreen Lotion SPF 50 PA+++",
		"coverPathId": 746,
		"createdBy": 50,
		"id": 39,
		"createdAt": "2020-11-28T11:44:04.884Z",
		"updatedAt": "2021-02-18T08:45:27.371Z",
		"__v": 0,
		"productCode": "39",
		"videoPath": [],
		"coverPath": {
			"type": "image",
			"path": "image/e625b5d9-4f6b-424e-b637-a59275aad996.jpg",
			"id": 746
		},
		"imagePath": [{
			"type": "image",
			"path": "image/e625b5d9-4f6b-424e-b637-a59275aad996.jpg",
			"id": 746
		}],
		"shop": {
			"logoPathId": 1410,
			"coverPathId": 1485,
			"imagePathIds": [],
			"videoPathIds": [],
			"name": "Banana Boat",
			"id": 7,
			"imagePath": [],
			"videoPath": [],
			"shopHub": {
				"address1": "467/11 โครงการมหาทุนพระราม 3",
				"address2": null,
				"location": {
					"lat": 13.689691,
					"lng": 100.512098
				},
				"primary": 0,
				"status": "show",
				"deleted": 0,
				"shopId": 7,
				"name": "Banana Boat",
				"mobile": "026891560",
				"subdistrict": "บางโคล่",
				"district": "บางคอแหลม",
				"province": "กรุงเทพมหานคร",
				"zipcode": "10120",
				"id": 6,
				"createdAt": "2020-11-27T08:45:22.262Z",
				"updatedAt": "2021-01-06T05:31:35.066Z",
				"__v": 0
			},
			"logoPath": {
				"type": "image",
				"path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
				"id": 1410
			},
			"coverPath": {
				"type": "image",
				"path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
				"id": 1485
			}
		},
		"productSkus": [{
			"productId": 39,
			"imagePathId": 749,
			"priceList": 720,
			"priceNet": 360,
			"priceCost": 288,
			"stockRemain": 973,
			"status": "show",
			"statusStock": "instock",
			"showOn": ["normal", "shelf", "live"],
			"sku": "39-175 ml",
			"id": 98,
			"imagePath": {
				"type": "image",
				"path": "image/0e7bd6a3-9861-48ec-b822-7d816edac017.jpg",
				"id": 749
			},
			"productDiscount": [],
			"attributeSKU": "175 ml"
		}],
		"priceNet": 360,
		"priceTotal": 720
	}, {
		"categories": ["health&beauty"],
		"productType": "general",
		"description": [{
			"contentType": "text",
			"content": "<p><strong>สเปรย์กันแดดสำหรับเล่นกีฬาที่ทำให้ผิวสัมผัสความเย็นยาวนาน</strong> เพื่อความรู้สึกสะอาดสดชื่น ปกป้องผิวจากการเผาไหม้ของแสงแดดมากกว่า 50 เท่า พร้อมปกป้องทั้งรังสียูวีเอและยูวีบีซึ่งเป็นสาเหตุของริ้วรอยและมะเร็งผิวหนัง<strong> กันแดดได้ยาวนานและกันน้ำได้ดีเยี่ยม</strong></p>"
		}],
		"nameEn": null,
		"advancePay": null,
		"imagePathIds": [754],
		"videoPathIds": [],
		"tags": [],
		"seo": {
			"title": "เล่นกีฬาสู้แดด! ใช้สเปรย์กันแดด แค่ฉีดผิวเย็นยาว กันน้ำได้ดี ",
			"description": "สเปรย์กันแดดสำหรับเล่นกีฬาที่ทำให้ผิวสัมผัสความเย็นยาวนาน เพื่อความรู้สึกสะอาดสดชื่น ปกป้องผิวจากการเผาไหม้ของแสงแดดมากกว่า 50 เท่า พร้อมปกป้องทั้งรังสียูวีเอและยูวีบีซึ่งเป็นสาเหตุของริ้วรอยและมะเร็งผิวหนัง กันแดดได้ยาวนานและกันน้ำได้ดีเยี่ยม",
			"keyword": ["Banana Boat", "สเปรย์กันแดด", "สเปรย์กันแดดสูตรเย็น", "กันแดดสำหรับเล่นกีฬา", "สเปรย์ฉีดผิว"],
			"seoImage": {
				"type": "image",
				"path": "image/d9e6daeb-f2ad-4ff8-9585-8a8e99464b36.jpg",
				"id": 756
			},
			"seoLength": {
				"title": "bad",
				"description": "bad",
				"keyword": "bad"
			},
			"permalink": "ultramist-sport-coolzone-sunscreen-lotion-spf-50+-pa+++",
			"seoImageId": 756
		},
		"unitType": "ชิ้น",
		"solds": 22,
		"remains": 978,
		"reserve": 0,
		"specifications": [],
		"skus": 1,
		"ribbon": [],
		"status": "show",
		"brand": "Banana Boat",
		"showOn": ["normal", "shelf", "live"],
		"platforms": ["callcenter", "web", "application"],
		"deleted": 0,
		"seoUpdatedAt": "2020-12-23T04:25:41.000Z",
		"freeShipping": 0,
		"conditionType": "new",
		"deliveryRules": 72,
		"prepareDay": 24,
		"shopId": 7,
		"saleType": "buynow",
		"name": "🌞 Banana Boat UltraMist Sport Coolzone Sunscreen Lotion SPF 50+ PA+++",
		"coverPathId": 754,
		"createdBy": 50,
		"id": 40,
		"createdAt": "2020-11-28T11:59:48.697Z",
		"updatedAt": "2021-02-18T11:49:26.021Z",
		"__v": 0,
		"productCode": "40",
		"videoPath": [],
		"coverPath": {
			"type": "image",
			"path": "image/221268ed-2027-4b29-901c-ee84dc0ef60e.jpg",
			"id": 754
		},
		"imagePath": [{
			"type": "image",
			"path": "image/221268ed-2027-4b29-901c-ee84dc0ef60e.jpg",
			"id": 754
		}],
		"shop": {
			"logoPathId": 1410,
			"coverPathId": 1485,
			"imagePathIds": [],
			"videoPathIds": [],
			"name": "Banana Boat",
			"id": 7,
			"imagePath": [],
			"videoPath": [],
			"shopHub": {
				"address1": "467/11 โครงการมหาทุนพระราม 3",
				"address2": null,
				"location": {
					"lat": 13.689691,
					"lng": 100.512098
				},
				"primary": 0,
				"status": "show",
				"deleted": 0,
				"shopId": 7,
				"name": "Banana Boat",
				"mobile": "026891560",
				"subdistrict": "บางโคล่",
				"district": "บางคอแหลม",
				"province": "กรุงเทพมหานคร",
				"zipcode": "10120",
				"id": 6,
				"createdAt": "2020-11-27T08:45:22.262Z",
				"updatedAt": "2021-01-06T05:31:35.066Z",
				"__v": 0
			},
			"logoPath": {
				"type": "image",
				"path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
				"id": 1410
			},
			"coverPath": {
				"type": "image",
				"path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
				"id": 1485
			}
		},
		"productSkus": [{
			"productId": 40,
			"imagePathId": 757,
			"priceList": 720,
			"priceNet": 360,
			"priceCost": 288,
			"stockRemain": 978,
			"status": "show",
			"statusStock": "instock",
			"showOn": ["normal", "shelf", "live"],
			"sku": "40-170 g",
			"id": 192,
			"imagePath": {
				"type": "image",
				"path": "image/ca5e00a2-74fa-4642-a6f7-df10822c3a77.jpg",
				"id": 757
			},
			"productDiscount": [],
			"attributeSKU": "170 g"
		}],
		"priceNet": 360,
		"priceTotal": 720
	}, {
		"categories": ["health&beauty"],
		"productType": "general",
		"description": [{
			"contentType": "text",
			"content": "<p>สเปรย์ป้องกันแสงแดดปกป้องผิวได้อย่างมีประสิทธิภาพด้วยค่า SPF ที่สูงถึง 50+ เนื้อเสปรย์บางเบาไม่เหนียวเหนอะหนะกันน้ำและหยาดเหงื่อได้เป็นอย่างดีและยังมี <strong>ส่วนผสมของ Moisture , Vitamin C , Vitamin E และ Aloe Vera</strong> เพื่อช่วยลดอาการผิวไหม้/แห้งและสามารถบำรุงผิวให้ผิวกลับมาเนียนนุ่มชุ่มชื้นหลังออกแดด</p>"
		}],
		"nameEn": null,
		"advancePay": null,
		"imagePathIds": [761],
		"videoPathIds": [],
		"tags": [],
		"seo": {
			"title": "สเปรย์กันแดด SPF สูงถึง 50+ กันน้ำ กันเหงื่อ ออกแดดหมดกังวล",
			"description": "สเปรย์ป้องกันแสงแดดปกป้องผิวได้อย่างมีประสิทธิภาพด้วยค่า SPF ที่สูงถึง 50+ เนื้อเสปรย์บางเบาไม่เหนียวเหนอะหนะกันน้ำและหยาดเหงื่อได้เป็นอย่างดีและยังมี ส่วนผสมของ Moisture , Vitamin C , Vitamin E และ Aloe Vera เพื่อช่วยลดอาการผิวไหม้/แห้งและสามารถบำรุงผิวให้ผิวกลับมาเนียนนุ่มชุ่มชื้นหลังออกแดด",
			"keyword": ["Banana Boat ", "สเปรย์กันแดด", "SPF  50+", "สเปรย์กันแดดกันน้ำ "],
			"seoImage": {
				"type": "image",
				"path": "image/70ff7cc5-3039-4267-8c65-ed296a6992b2.jpg",
				"id": 762
			},
			"seoLength": {
				"title": "bad",
				"description": "bad",
				"keyword": "good"
			},
			"permalink": "clearสเปรย์กันแดด-spf-สูงถึง-50+-กันน้ำ-กันเหงื่อ-ออกแดดหมดกังวล",
			"seoImageId": 762
		},
		"unitType": "ชิ้น",
		"solds": 3,
		"remains": 998,
		"reserve": -1,
		"specifications": [],
		"skus": 1,
		"ribbon": [],
		"status": "show",
		"brand": "Banana Boat",
		"showOn": ["live", "shelf", "normal"],
		"platforms": ["callcenter", "web", "application"],
		"deleted": 0,
		"seoUpdatedAt": "2021-01-20T07:01:45.000Z",
		"freeShipping": 0,
		"conditionType": "new",
		"deliveryRules": 72,
		"prepareDay": 24,
		"shopId": 7,
		"saleType": "buynow",
		"name": "🌞 Banana Boat Clear Ultra Mist Protect & Hydrate SPF 50+ PA+++",
		"coverPathId": 761,
		"createdBy": 50,
		"id": 41,
		"createdAt": "2020-11-28T12:16:33.625Z",
		"updatedAt": "2021-02-16T11:44:20.527Z",
		"__v": 0,
		"productCode": "41",
		"videoPath": [],
		"coverPath": {
			"type": "image",
			"path": "image/f5e4607c-6d33-4406-849c-aee448e993ab.jpg",
			"id": 761
		},
		"imagePath": [{
			"type": "image",
			"path": "image/f5e4607c-6d33-4406-849c-aee448e993ab.jpg",
			"id": 761
		}],
		"shop": {
			"logoPathId": 1410,
			"coverPathId": 1485,
			"imagePathIds": [],
			"videoPathIds": [],
			"name": "Banana Boat",
			"id": 7,
			"imagePath": [],
			"videoPath": [],
			"shopHub": {
				"address1": "467/11 โครงการมหาทุนพระราม 3",
				"address2": null,
				"location": {
					"lat": 13.689691,
					"lng": 100.512098
				},
				"primary": 0,
				"status": "show",
				"deleted": 0,
				"shopId": 7,
				"name": "Banana Boat",
				"mobile": "026891560",
				"subdistrict": "บางโคล่",
				"district": "บางคอแหลม",
				"province": "กรุงเทพมหานคร",
				"zipcode": "10120",
				"id": 6,
				"createdAt": "2020-11-27T08:45:22.262Z",
				"updatedAt": "2021-01-06T05:31:35.066Z",
				"__v": 0
			},
			"logoPath": {
				"type": "image",
				"path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
				"id": 1410
			},
			"coverPath": {
				"type": "image",
				"path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
				"id": 1485
			}
		},
		"productSkus": [{
			"productId": 41,
			"imagePathId": 767,
			"priceList": 790,
			"priceNet": 395,
			"priceCost": 316,
			"stockRemain": 998,
			"status": "show",
			"statusStock": "instock",
			"showOn": ["normal", "shelf", "live"],
			"sku": "41-170 g",
			"id": 193,
			"imagePath": {
				"type": "image",
				"path": "image/1617848d-d29f-4b8b-a36a-11203326c00a.jpg",
				"id": 767
			},
			"productDiscount": [],
			"attributeSKU": "170 g"
		}],
		"priceNet": 395,
		"priceTotal": 790
	}, {
		"categories": ["health&beauty"],
		"productType": "general",
		"description": [{
			"contentType": "text",
			"content": "<p>ผลิตภัณฑ์บำรุงผิวผสมสารป้องกันแดดและทำผิวเป็นสีแทนธรรมชาติ มีส่วนผสมของสารสกัดจากแครอทและกล้วย ช่วยบำรุงให้ผิวเนียนนุ่ม ชุ่มชื่น และทำให้ผิวเป็นสีแทนทองได้นานอย่างธรรมชาติ พร้อมช่วย <strong>ปกป้องผิวจากการเผาไหม้ของแสงแดดถึง 8 เท่า</strong></p>"
		}],
		"nameEn": null,
		"advancePay": null,
		"imagePathIds": [774],
		"videoPathIds": [],
		"tags": [],
		"seo": {
			"title": "Protective Tanning Oil SPF 8 บำรุงผิวด้วยสารสกัดจากธรรมชาติ",
			"description": "ผลิตภัณฑ์บำรุงผิวผสมสารป้องกันแดดและทำผิวเป็นสีแทนธรรมชาติ มีส่วนผสมของสารสกัดจากแครอทและกล้วย ช่วยบำรุงให้ผิวเนียนนุ่ม ชุ่มชื่น และทำให้ผิวเป็นสีแทนทองได้นานอย่างธรรมชาติ พร้อมช่วย ปกป้องผิวจากการเผาไหม้ของแสงแดดถึง 8 เท่า",
			"keyword": ["Banana Boat", "ครีมกันแดด", " ผลิตภัณฑ์บำรุงผสมกันแดด"],
			"seoImage": {
				"type": "image",
				"path": "image/daba2c3e-ec8d-4de4-9f53-8044577130ba.jpg",
				"id": 776
			},
			"seoLength": {
				"title": "bad",
				"description": "bad",
				"keyword": "bad"
			},
			"permalink": "protective-tanning-oil-spf-8",
			"seoImageId": 776
		},
		"unitType": "ชิ้น",
		"solds": 13,
		"remains": 1985,
		"reserve": 2,
		"specifications": [],
		"skus": 1,
		"ribbon": [],
		"status": "show",
		"brand": "Banana Boat",
		"showOn": ["live", "shelf"],
		"platforms": ["callcenter", "web", "application"],
		"deleted": 0,
		"seoUpdatedAt": "2021-01-20T08:52:22.000Z",
		"freeShipping": 0,
		"conditionType": "new",
		"deliveryRules": 72,
		"prepareDay": 24,
		"shopId": 7,
		"saleType": "buynow",
		"name": "🌞 Banana Boat Protective Tanning Oil SPF 8",
		"coverPathId": 774,
		"createdBy": 50,
		"id": 42,
		"createdAt": "2020-11-28T12:29:15.507Z",
		"updatedAt": "2021-02-18T11:49:51.287Z",
		"__v": 0,
		"productCode": "42",
		"videoPath": [],
		"coverPath": {
			"type": "image",
			"path": "image/ac0170f9-57ad-4fe5-b765-30af58d06614.jpg",
			"id": 774
		},
		"imagePath": [{
			"type": "image",
			"path": "image/ac0170f9-57ad-4fe5-b765-30af58d06614.jpg",
			"id": 774
		}],
		"shop": {
			"logoPathId": 1410,
			"coverPathId": 1485,
			"imagePathIds": [],
			"videoPathIds": [],
			"name": "Banana Boat",
			"id": 7,
			"imagePath": [],
			"videoPath": [],
			"shopHub": {
				"address1": "467/11 โครงการมหาทุนพระราม 3",
				"address2": null,
				"location": {
					"lat": 13.689691,
					"lng": 100.512098
				},
				"primary": 0,
				"status": "show",
				"deleted": 0,
				"shopId": 7,
				"name": "Banana Boat",
				"mobile": "026891560",
				"subdistrict": "บางโคล่",
				"district": "บางคอแหลม",
				"province": "กรุงเทพมหานคร",
				"zipcode": "10120",
				"id": 6,
				"createdAt": "2020-11-27T08:45:22.262Z",
				"updatedAt": "2021-01-06T05:31:35.066Z",
				"__v": 0
			},
			"logoPath": {
				"type": "image",
				"path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
				"id": 1410
			},
			"coverPath": {
				"type": "image",
				"path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
				"id": 1485
			}
		},
		"productSkus": [{
			"productId": 42,
			"imagePathId": 777,
			"priceList": 500,
			"priceNet": 300,
			"priceCost": 196,
			"stockRemain": 995,
			"status": "show",
			"statusStock": "instock",
			"showOn": ["shelf", "live"],
			"sku": "42-236 ml",
			"id": 101,
			"imagePath": {
				"type": "image",
				"path": "image/bb0bf79a-cd79-493b-a399-c5e78ca32ce7.jpg",
				"id": 777
			},
			"productDiscount": [],
			"attributeSKU": "236 ml"
		}, {
			"productId": 42,
			"imagePathId": 774,
			"priceList": 500,
			"priceNet": 100,
			"priceCost": 123,
			"stockRemain": 990,
			"status": "show",
			"statusStock": "instock",
			"showOn": ["shelf", "live"],
			"sku": "42-300",
			"id": 266,
			"imagePath": {
				"type": "image",
				"path": "image/ac0170f9-57ad-4fe5-b765-30af58d06614.jpg",
				"id": 774
			},
			"productDiscount": [],
			"attributeSKU": "300"
		}],
		"priceNet": 100,
		"priceTotal": 500
	}, {
		"categories": ["Babies & Kids"],
		"productType": "general",
		"description": [{
			"contentType": "text",
			"content": "<p>Nendoroid 1221 Yusuke Urameshi Yu Yu Hakusho ของแท้ 100%  ฟิกเกอร์ โมเดล GoodSmile</p><p><br></p><p>สินค้า: Nendoroid (เนนโดรอยด์)</p><p>วัสดุ : PAINTED ABS&amp;PVC with stand included</p><p>สเปค : NON Scale ประมาณ 10 ซม.</p><p>ผู้ผลิต: Good Smile Company</p><p><br></p><p>👉  สินค้าลิขสิทธิ์แท้  💯%   LOT JAPAN 🇯🇵 (ญี่ปุ่น)</p><p><br></p><p>👉  สินค้าทุกรายการพร้อมส่งคะ</p><p><br></p><p><br></p><p>*********************</p><p>📦 ลงทะเบียน 70บาท</p><p>📦 EMS 100บาท</p><p>*********************</p><p><br></p><p>📲 : 082-907-7207</p><p>Line id: @toyzelect  📌มี @ ด้วยนะคะ 📌</p><p>Facebook : https://www.facebook.com/ToyZelect/</p>"
		}],
		"nameEn": null,
		"advancePay": null,
		"imagePathIds": [1579, 1580],
		"videoPathIds": [],
		"tags": [],
		"seo": {
			"title": "Nendoroid 1221 Yusuke Urameshi Yu Yu Hakusho ของแท้ 100%",
			"description": "Nendoroid 1221 Yusuke Urameshi Yu Yu Hakusho ของแท้ 100%",
			"keyword": ["nendoroidl", "Nendoroid", "NendoroidThailand", "YusukeUrameshi"],
			"seoImage": {
				"type": "image",
				"path": "image/680ea7fd-7eb2-4dba-94df-703ac3ffbea5.jpeg",
				"id": 1579
			},
			"seoLength": {
				"title": "bad",
				"description": "bad",
				"keyword": "good"
			},
			"permalink": "Yusuke-nendoroid",
			"seoImageId": 1579
		},
		"unitType": "ชิ้น",
		"solds": 2,
		"remains": 2,
		"reserve": 0,
		"specifications": [],
		"skus": 1,
		"ribbon": [],
		"status": "show",
		"brand": "Good Smile",
		"showOn": ["live", "shelf", "normal"],
		"platforms": ["callcenter", "web", "application"],
		"deleted": 0,
		"seoUpdatedAt": "2021-02-10T09:33:04.000Z",
		"freeShipping": 0,
		"conditionType": "new",
		"deliveryRules": 72,
		"prepareDay": 24,
		"shopId": 7,
		"saleType": "buynow",
		"name": "Nendoroid 1221 Yusuke Urameshi Yu Yu Hakusho ของแท้ 100%  ฟิกเกอร์ โมเดล GoodSmile",
		"coverPathId": 1579,
		"createdBy": 50,
		"id": 195,
		"createdAt": "2021-02-10T09:33:05.013Z",
		"updatedAt": "2021-02-11T06:21:15.761Z",
		"__v": 0,
		"productCode": "195",
		"videoPath": [],
		"coverPath": {
			"type": "image",
			"path": "image/680ea7fd-7eb2-4dba-94df-703ac3ffbea5.jpeg",
			"id": 1579
		},
		"imagePath": [{
			"type": "image",
			"path": "image/680ea7fd-7eb2-4dba-94df-703ac3ffbea5.jpeg",
			"id": 1579
		}, {
			"type": "image",
			"path": "image/57486319-ad97-4f06-9656-210e7ea6a670.jpeg",
			"id": 1580
		}],
		"shop": {
			"logoPathId": 1410,
			"coverPathId": 1485,
			"imagePathIds": [],
			"videoPathIds": [],
			"name": "Banana Boat",
			"id": 7,
			"imagePath": [],
			"videoPath": [],
			"shopHub": {
				"address1": "467/11 โครงการมหาทุนพระราม 3",
				"address2": null,
				"location": {
					"lat": 13.689691,
					"lng": 100.512098
				},
				"primary": 0,
				"status": "show",
				"deleted": 0,
				"shopId": 7,
				"name": "Banana Boat",
				"mobile": "026891560",
				"subdistrict": "บางโคล่",
				"district": "บางคอแหลม",
				"province": "กรุงเทพมหานคร",
				"zipcode": "10120",
				"id": 6,
				"createdAt": "2020-11-27T08:45:22.262Z",
				"updatedAt": "2021-01-06T05:31:35.066Z",
				"__v": 0
			},
			"logoPath": {
				"type": "image",
				"path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
				"id": 1410
			},
			"coverPath": {
				"type": "image",
				"path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
				"id": 1485
			}
		},
		"productSkus": [{
			"productId": 195,
			"imagePathId": 1579,
			"priceList": 1800,
			"priceNet": 1600,
			"priceCost": 1400,
			"stockRemain": 2,
			"status": "show",
			"statusStock": "instock",
			"showOn": ["normal", "shelf", "live"],
			"sku": "195-md",
			"id": 405,
			"imagePath": {
				"type": "image",
				"path": "image/680ea7fd-7eb2-4dba-94df-703ac3ffbea5.jpeg",
				"id": 1579
			},
			"productDiscount": [],
			"attributeSKU": "md"
		}],
		"priceNet": 1600,
		"priceTotal": 1800
	}],
	"count": 11
}
export const post = {
    "descriptions": [],
    "coverPathId": 1410,
    "ribbon": [],
    "liveStatus": "wait",
    "liveViews": 0,
    "type": "live",
    "hasRotated": false,
    "status": "show",
    "deleted": 0,
    "releaseDate": "2021-02-25T07:07:00.000Z",
    "readyDate": null,
    "publishDate": null,
    "finishDate": null,
    "expireDate": "2021-02-03T09:52:13.745Z",
    "paymentExpireUnit": 4,
    "chatLogCreatedAt": null,
    "shopId": 7,
    "staffId": 50,
    "title": "SALE",
    "seo": {
        "permalink": "1611718163917"
    },
    "id": 634,
    "createdAt": "2021-01-27T03:29:23.991Z",
    "updatedAt": "2021-02-19T09:39:35.029Z",
    "createdBy": 50,
    "roomId": "6010de13c6a9d8007791e4fc",
    "streamKey": "92KzBtsoSGHvHWe9",
    "streamUrl": "rtmp://obs-rtmp.godang.live:1935/live?streamKey=92KzBtsoSGHvHWe9",
    "staff": {
        "displayName": null,
        "email": "nan15594@gmail.com",
        "username": "adminoutlet@oll.com",
        "profileImage": null,
        "id": 50
    },
    "cover": {
        "type": "image",
        "path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
        "id": 1410
    },
    "shop": {
        "nameEn": null,
        "status": "request",
        "description": "หากพูดถึงครีมกันแดดตัวท็อปในตำนาน คงไม่มีใครไม่รู้จัก Banana Boat แบรนด์กันแดดที่ทำให้สาวๆรู้จัก ศัตรูผิวหมองตัวฉกาจอย่าง “น้องแดดเมืองไทย” ของเรานี่เอง “Banana Boat” ที่สุดของครีมกันแดดจากผู้เชี่ยวชาญด้านครีมกันแดดโดยเฉพาะจากสหรัฐอเมริกา ที่ก่อตั้งมายาวนานกว่า 20 ปีการันตีประสิทธิภาพการปกป้องขั้นสุดด้วยปรากฏการณ์รีวิวปากต่อปากจนกลายเป็น “ตำนาน” ที่สาว ๆ พูดกันติดปากว่า “อยากผิวไบรท์ต้องใช้ Banana Boat”ไม่ว่าจะท่องเที่ยว หรือทำงานก็เอาไปเลย 10 เต็ม 10 ! ปกป้องดีกว่านี้ไม่มีอีกแล้วจ้าาาาาา!!! ด้วยกันแดดที่เพิ่มความแอ๊ดว๊านซ์จากน้องส้มSPF50ด้านบน ให้กลายเป็น “น้องส้มจี๊ด” ที่มาพร้อมปกป้องสูงสุดด้วย SPF50+ และ PAสามบวก ที่สุดของกันแดดไร้เทียมทานจาก Banana Boat กันน้ำ และเหงื่อระดับเต็มแม็กซ์ เพื่อสายกิจกรรมกลางแจ้งแบบจัดหนัก ท้าทุกแดด ลุยทุกฝนจุดแข็ง: เนื้อครีมเข้มข้น เพื่อการปกป้องขั้นสุด กันน้ำ และเหงื่อเป็นเลิศ  Banna Boat แบรนด์กันแดด โดยผู้เชี่ยวชาญด้านครีมกันแดดโดยเฉพาะ จากประเทศญี่ปุ่น สำรวจไลฟ์สไตล์ และความต้องการจริงของสาวไทยยุค 5.0 โดยรวบรวมทุกปัญหากันแดดของผู้หญิงเพื่อให้ความสวยเป็นเรื่องง่าย สู่แรงบันดาลใจในการสร้างสรรค์กันแดดที่ดีที่สุดจาก Banana Boat อย่าง Banana Boat Simply Protect Aqua SPF50+ สูตร Daily Moistureสำหรับใช้เป็นประจำทุกวันมาพร้อมประสิทธิภาพกันแดดเต็มที่ ผสาน Hyaluronic Acid สารบำรุงผิวนุ่มชุ่มชื่นปรับสภาพผิวให้พร้อมแต่งหน้าได้ทันที สูตร Long Wearing Moisture สำหรับกิจกรรมกลางแจ้ง เพิ่มประสิทธิภาพกันแดดยาวนาน กันน้ำ และเหงื่อดีเยี่ยม",
        "zone": "บางคอแหลม",
        "logoPathId": 1410,
        "coverPathId": 1485,
        "imagePathIds": [],
        "videoPathIds": [],
        "tags": [],
        "taxType": "personality",
        "sharingShop": 90,
        "sharingPlatform": 10,
        "seo": {
            "title": "Banana Boat",
            "description": "Banana Boat",
            "keyword": ["Banana Boat"],
            "seoLength": {
                "title": "bad",
                "description": "bad",
                "keyword": "bad"
            },
            "permalink": "banana-boat",
            "seoImageId": 411
        },
        "digitalItems": 0,
        "generalItems": 16,
        "name": "Banana Boat",
        "id": 7,
        "createdAt": "2020-11-27T08:40:22.410Z",
        "updatedAt": "2021-02-10T09:33:05.179Z",
        "shopCode": "7",
        "imagePath": [],
        "videoPath": [],
        "coverPath": {
            "type": "image",
            "path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
            "id": 1485
        },
        "logoPath": {
            "type": "image",
            "path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
            "id": 1410
        }
    },
    "items": [{
        "id": 1488,
        "order": 1,
        "showOn": ["shelf"],
        "skuId": 92,
        "sku": "33-90 ml",
        "skuShowOn": ["normal", "shelf", "live"],
        "productId": 33,
        "brand": "Banana Boat",
        "productName": "🌞 Banana Boat Ultra Protect Sunscreen Lotion SPF 50 PA",
        "productNameEn": null,
        "imagePath": {
            "type": "image",
            "path": "image/69f84092-ad20-472f-98f7-68a5e1ad555a.jpg",
            "id": 215
        },
        "priceList": 435,
        "priceNet": 206,
        "priceDeposit": 0,
        "priceCost": 174,
        "priceGP": 2000,
        "priceVat": 0,
        "wholesaleRate": 0,
        "weight": 0.108,
        "statusStock": "instock",
        "priceDiscount": 11,
        "discountValue": 5,
        "discountValueUnit": "percent",
        "solds": 5,
        "inCart": 0,
        "quotas": 4,
        "quotaRemains": 4,
        "limitPerUser": 2,
        "costSharingPlatform": 0,
        "costSharingPartner": 0,
        "updatedAt": "2021-02-19T09:39:35.312Z"
    }, {
        "id": 1486,
        "order": 2,
        "showOn": ["live"],
        "skuId": 93,
        "sku": "34-90 ml",
        "skuShowOn": ["shelf", "live"],
        "productId": 34,
        "brand": "Banana Boat",
        "productName": "🌞 Banana Boat Dry Balance Sunscreen Lotion SPF 50+ PA+++",
        "productNameEn": null,
        "imagePath": {
            "type": "image",
            "path": "image/003a8f72-281e-40cc-899f-bcaa8ffa3e4e.jpg",
            "id": 709
        },
        "priceList": 480,
        "priceNet": 228,
        "priceDeposit": 0,
        "priceCost": 192,
        "priceGP": 2000,
        "priceVat": 0,
        "wholesaleRate": 0,
        "weight": 0.108,
        "statusStock": "instock",
        "priceDiscount": 12,
        "discountValue": 5,
        "discountValueUnit": "percent",
        "solds": 51,
        "inCart": 0,
        "quotas": 4,
        "quotaRemains": 4,
        "limitPerUser": 3,
        "costSharingPlatform": 0,
        "costSharingPartner": 0,
        "updatedAt": "2021-02-19T09:39:35.312Z"
    }, {
        "id": 1487,
        "order": 3,
        "showOn": ["shelf", "live"],
        "skuId": 95,
        "sku": "36-50 ml",
        "skuShowOn": ["normal", "shelf", "live"],
        "productId": 36,
        "brand": "Banana Boat",
        "productName": "🌞 Banana Boat Simply Aqua Long Wearing Sunscreen Lotion SPF 50+ PA++++",
        "productNameEn": null,
        "imagePath": {
            "type": "image",
            "path": "image/3d62c79d-5052-4026-b29e-fedb284a4560.jpg",
            "id": 727
        },
        "priceList": 390,
        "priceNet": 185,
        "priceDeposit": 0,
        "priceCost": 156,
        "priceGP": 2000,
        "priceVat": 0,
        "wholesaleRate": 0,
        "weight": 0.077,
        "statusStock": "instock",
        "priceDiscount": 10,
        "discountValue": 5,
        "discountValueUnit": "percent",
        "solds": 44,
        "inCart": 0,
        "quotas": 4,
        "quotaRemains": 4,
        "limitPerUser": 5,
        "costSharingPlatform": 0,
        "costSharingPartner": 0,
        "updatedAt": "2021-02-19T09:39:35.312Z"
    }],
    "liveDuration": 0
}
export const productss = [{
    "categories": ["fashion"],
    "productType": "general",
    "description": [{
        "contentType": "text",
        "content": "<p><strong>โลชั่นกันแดดสำหรับกีฬาทุกชนิด หรือกิจกรรม Outdoor</strong> ช่วยปกป้องผิวจากการเผาไหม้ของแสงแดดได้มากกว่า 50 เท่า <strong>พร้อมปกป้องทั้งรังสียูวีเอและยูวีบี </strong>กันแดดได้ยาวนาน <strong><u>กันน้ำกันเหงื่อได้ดีเยี่ยม</u></strong></p>"
    }],
    "nameEn": null,
    "advancePay": null,
    "imagePathIds": [683],
    "videoPathIds": [],
    "tags": [],
    "seo": {
        "title": "โลชั่นกันแดด Sport Sunscreen Lotion พร้อมพาผิวสวยๆ ลุยได้ทุกที่",
        "description": "โลชั่นกันแดดสำหรับกีฬาทุกชนิด หรือกิจกรรม Outdoor ช่วยปกป้องผิวจากการเผาไหม้ของแสงแดดได้มากกว่า 50 เท่า พร้อมปกป้องทั้งรังสียูวีเอและยูวีบี กันแดดได้ยาวนาน กันน้ำกันเหงื่อได้ดีเยี่ยม",
        "keyword": ["Banana Boat", "โลชั่นกันแดด", "กันแดดกันน้ำกันเหงื่อ", "SPF 50+ PA+++"],
        "seoImage": {
            "type": "image",
            "path": "image/a9b96935-0723-485d-8847-6b2753db6609.jpg",
            "id": 684
        },
        "seoLength": {
            "title": "bad",
            "description": "bad",
            "keyword": "bad"
        },
        "permalink": "sport-sunscreen-lotion-spf-50+-pa+++",
        "seoImageId": 684
    },
    "unitType": "ชิ้น",
    "solds": 40,
    "remains": 959,
    "reserve": 1,
    "specifications": [],
    "skus": 1,
    "ribbon": [],
    "status": "show",
    "brand": "Banana Boat",
    "showOn": ["live", "shelf"],
    "platforms": ["callcenter", "web", "application"],
    "deleted": 0,
    "seoUpdatedAt": "2021-02-19T10:18:06.000Z",
    "freeShipping": 0,
    "conditionType": "new",
    "deliveryRules": 72,
    "prepareDay": 24,
    "shopId": 7,
    "saleType": "buynow",
    "name": "🌞 Banana Boat Sport Sunscreen Lotion SPF 50+ PA+++",
    "coverPathId": 683,
    "createdBy": 50,
    "id": 32,
    "createdAt": "2020-11-28T10:10:14.341Z",
    "updatedAt": "2021-02-19T10:18:07.239Z",
    "__v": 0,
    "productCode": "32",
    "videoPath": [],
    "coverPath": {
        "type": "image",
        "path": "image/eeb235e6-8efa-4858-91ca-b84824f0e317.jpg",
        "id": 683
    },
    "imagePath": [{
        "type": "image",
        "path": "image/eeb235e6-8efa-4858-91ca-b84824f0e317.jpg",
        "id": 683
    }],
    "shop": {
        "logoPathId": 1410,
        "coverPathId": 1485,
        "imagePathIds": [],
        "videoPathIds": [],
        "name": "Banana Boat",
        "id": 7,
        "imagePath": [],
        "videoPath": [],
        "shopHub": {
            "address1": "467/11 โครงการมหาทุนพระราม 3",
            "address2": null,
            "location": {
                "lat": 13.689691,
                "lng": 100.512098
            },
            "primary": 0,
            "status": "show",
            "deleted": 0,
            "shopId": 7,
            "name": "Banana Boat",
            "mobile": "026891560",
            "subdistrict": "บางโคล่",
            "district": "บางคอแหลม",
            "province": "กรุงเทพมหานคร",
            "zipcode": "10120",
            "id": 6,
            "createdAt": "2020-11-27T08:45:22.262Z",
            "updatedAt": "2021-01-06T05:31:35.066Z",
            "__v": 0
        },
        "logoPath": {
            "type": "image",
            "path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
            "id": 1410
        },
        "coverPath": {
            "type": "image",
            "path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
            "id": 1485
        }
    },
    "productSkus": [{
        "productId": 32,
        "imagePathId": 685,
        "priceList": 535,
        "priceNet": 267,
        "priceCost": 214,
        "stockRemain": 959,
        "status": "show",
        "statusStock": "instock",
        "showOn": ["shelf", "live"],
        "sku": "32-90 ml",
        "id": 91,
        "imagePath": {
            "type": "image",
            "path": "image/103462cc-ca44-4bf6-80bc-cb7e88177582.jpg",
            "id": 685
        },
        "productDiscount": [],
        "attributeSKU": "90 ml",
        "select": false,
        "extraPrice": {
            "discountPrice": null,
            "discountPercent": null,
            "buyLimit": null,
            "privileges": null
        },
        "errors": {}
    }],
    "priceNet": 267,
    "priceTotal": 535
}, {
    "categories": ["fashion"],
    "productType": "general",
    "description": [{
        "contentType": "text",
        "content": "<p>โลชั่นกันแดดสำหรับปกป้องผิวทุกวันเนื้อครีมบางเบาไม่เหนียวเหนอะหนะ ซึมซาบเร็วไม่อุดตันรูขุมขน<strong>มีส่วนผสมของว่านหางจระเข้ วิตามินซีและอี ช่วยให้ผิวเนียนนุ่มชุ่มชื้น</strong> พร้อมช่วยปกป้องผิวจากการเผาไหม้ของแสงแดดถึง 50 เท่า พร้อมปกป้องทั้งรังสียูวีเอและยูวีบี ซึ่งเป็นสาเหตุของริ้วรอยและมะเร็งผิวหนัง กันแดดได้ยาวนาน กันน้ำได้ดีเยี่ยมมีกลิ่นหอมธรรมชาติ</p>"
    }],
    "nameEn": null,
    "advancePay": null,
    "imagePathIds": [213],
    "videoPathIds": [],
    "tags": [],
    "seo": {
        "title": "ริ้วรอยกระเด็น!  กันแดดยาวนาน ด้วย Ultra Protect Sunscreen Lotion",
        "description": "Ultra Protect Sunscreen Lotion SPF 50 PA+++ โลชั่นกันแดด พร้อมส่วนผสมของว่านหางจระเข้ วิตามินซีและอี ช่วยให้ผิวเนียนนุ่มชุ่มชื้นช่วยให้ผิวเนียนนุ่มชุ่มชื่น ช่วยปกป้องผิวจากการเผาไหม้ของแสงแดดถึง 50 เท่า ทั้งรังสี UVA และ UVB",
        "keyword": ["โลชั่นกันแดด", " Banana Boat", "กันแดดบำรุงผิว ", "กันแดดครีมซึมไว", "กันแดดกันน้ำ", "SPF 50 PA+++"],
        "seoImage": {
            "type": "image",
            "path": "image/9687b777-6198-4f73-8e52-5fe3285d0459.jpg",
            "id": 214
        },
        "seoLength": {
            "title": "bad",
            "description": "bad",
            "keyword": "good"
        },
        "permalink": "ultra-protect-sunscreen-lotion-spf-50-pa+++",
        "seoImageId": 214
    },
    "unitType": "ชิ้น",
    "solds": 5,
    "remains": 994,
    "reserve": 1,
    "specifications": [],
    "skus": 1,
    "ribbon": [],
    "status": "show",
    "brand": "Banana Boat",
    "showOn": ["live", "shelf", "normal"],
    "platforms": ["callcenter", "web", "application"],
    "deleted": 0,
    "seoUpdatedAt": "2021-02-19T09:40:33.000Z",
    "freeShipping": 0,
    "conditionType": "new",
    "deliveryRules": 72,
    "prepareDay": 24,
    "shopId": 7,
    "saleType": "buynow",
    "name": "🌞 Banana Boat Ultra Protect Sunscreen Lotion SPF 50 PA",
    "coverPathId": 213,
    "createdBy": 50,
    "id": 33,
    "createdAt": "2020-11-28T10:26:20.647Z",
    "updatedAt": "2021-02-19T09:40:34.024Z",
    "__v": 0,
    "productCode": "33",
    "videoPath": [],
    "coverPath": {
        "type": "image",
        "path": "image/3ba27607-199f-4b5e-a683-ab5f2615a8cc.jpg",
        "id": 213
    },
    "imagePath": [{
        "type": "image",
        "path": "image/3ba27607-199f-4b5e-a683-ab5f2615a8cc.jpg",
        "id": 213
    }],
    "shop": {
        "logoPathId": 1410,
        "coverPathId": 1485,
        "imagePathIds": [],
        "videoPathIds": [],
        "name": "Banana Boat",
        "id": 7,
        "imagePath": [],
        "videoPath": [],
        "shopHub": {
            "address1": "467/11 โครงการมหาทุนพระราม 3",
            "address2": null,
            "location": {
                "lat": 13.689691,
                "lng": 100.512098
            },
            "primary": 0,
            "status": "show",
            "deleted": 0,
            "shopId": 7,
            "name": "Banana Boat",
            "mobile": "026891560",
            "subdistrict": "บางโคล่",
            "district": "บางคอแหลม",
            "province": "กรุงเทพมหานคร",
            "zipcode": "10120",
            "id": 6,
            "createdAt": "2020-11-27T08:45:22.262Z",
            "updatedAt": "2021-01-06T05:31:35.066Z",
            "__v": 0
        },
        "logoPath": {
            "type": "image",
            "path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
            "id": 1410
        },
        "coverPath": {
            "type": "image",
            "path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
            "id": 1485
        }
    },
    "productSkus": [{
        "productId": 33,
        "imagePathId": 215,
        "priceList": 435,
        "priceNet": 217,
        "priceCost": 174,
        "stockRemain": 994,
        "status": "show",
        "statusStock": "instock",
        "showOn": ["normal", "shelf", "live"],
        "sku": "33-90 ml",
        "id": 92,
        "imagePath": {
            "type": "image",
            "path": "image/69f84092-ad20-472f-98f7-68a5e1ad555a.jpg",
            "id": 215
        },
        "productDiscount": [],
        "attributeSKU": "90 ml",
        "select": true,
        "extraPrice": {
            "discountPrice": 217,
            "discountPercent": 0,
            "buyLimit": 2,
            "privileges": 4
        },
        "errors": {},
        "itemId": 1488
    }],
    "priceNet": 217,
    "priceTotal": 435
}, {
    "categories": ["health&beauty"],
    "productType": "general",
    "description": [{
        "contentType": "text",
        "content": "<p>โลชั่นปกป้องแสงแดดสูตร<strong>เนื้อครีมบางเบา</strong>สามารถทำกิจกรรมท่ามกลางแสงแดดได้ยาวนานโดยปราศจากความเหนียวเหนอะหนะด้วยสูตรเฉพาะของบานาน่าโบ๊ทเนื้อโลชั่นสามารถปกป้องรังสี UVA/UVB ได้อย่างมีประสิทธิภาพ เนื้อโลชั่นซึมซาบเร็วไม่อุดตันรูขุมขนทำให้รู้สึกสบายผิวขณะใช้และสามารถบำรุงผิวกายให้กลับมาดูกระจ่างใสมีชีวิตชีวาอีกครั้งหลังออกแดด</p>"
    }],
    "nameEn": null,
    "advancePay": null,
    "imagePathIds": [702],
    "videoPathIds": [],
    "tags": [],
    "seo": {
        "title": "Dry Balance Sunscreen Lotion เนื้อบางเบา ไม่เหนอะ พร้อมบำรุงผิว",
        "description": "เนื้อโลชั่นซึมซาบเร็วไม่อุดตันรูขุมขนทำให้รู้สึกสบายผิวขณะใช้และสามารถบำรุงผิวกายให้กลับมาดูกระจ่างใสมีชีวิตชีวาอีกครั้งหลังออกแดด ด้วยสูตรเฉพาะของบานาน่าโบ๊ทเนื้อโลชั่นสามารถปกป้องรังสี UVA/UVB ",
        "keyword": ["โลชั่นกันแดด", " Banana Boat", " SPF50+  PA++++", "กันแดด ปกป้องรังสี UVA/UVB", "กันแดดสูตรบำรุงผิว "],
        "seoImage": {
            "type": "image",
            "path": "image/b157f131-0620-4358-a017-68086bf924a7.jpg",
            "id": 707
        },
        "seoLength": {
            "title": "bad",
            "description": "bad",
            "keyword": "good"
        },
        "permalink": "dry-balance-sunscreen-lotion-spf-50+-pa+++",
        "seoImageId": 707
    },
    "unitType": "ชิ้น",
    "solds": 51,
    "remains": 977,
    "reserve": -28,
    "specifications": [],
    "skus": 1,
    "ribbon": [],
    "status": "show",
    "brand": "Banana Boat",
    "showOn": ["live", "shelf"],
    "platforms": ["callcenter", "web", "application"],
    "deleted": 0,
    "seoUpdatedAt": "2021-01-20T08:59:09.000Z",
    "freeShipping": 0,
    "conditionType": "new",
    "deliveryRules": 72,
    "prepareDay": 24,
    "shopId": 7,
    "saleType": "buynow",
    "name": "🌞 Banana Boat Dry Balance Sunscreen Lotion SPF 50+ PA+++",
    "coverPathId": 702,
    "createdBy": 50,
    "id": 34,
    "createdAt": "2020-11-28T10:40:20.803Z",
    "updatedAt": "2021-02-18T11:50:06.186Z",
    "__v": 0,
    "productCode": "34",
    "videoPath": [],
    "coverPath": {
        "type": "image",
        "path": "image/661da8f0-ace1-49fc-814b-816994ffae1a.jpg",
        "id": 702
    },
    "imagePath": [{
        "type": "image",
        "path": "image/661da8f0-ace1-49fc-814b-816994ffae1a.jpg",
        "id": 702
    }],
    "shop": {
        "logoPathId": 1410,
        "coverPathId": 1485,
        "imagePathIds": [],
        "videoPathIds": [],
        "name": "Banana Boat",
        "id": 7,
        "imagePath": [],
        "videoPath": [],
        "shopHub": {
            "address1": "467/11 โครงการมหาทุนพระราม 3",
            "address2": null,
            "location": {
                "lat": 13.689691,
                "lng": 100.512098
            },
            "primary": 0,
            "status": "show",
            "deleted": 0,
            "shopId": 7,
            "name": "Banana Boat",
            "mobile": "026891560",
            "subdistrict": "บางโคล่",
            "district": "บางคอแหลม",
            "province": "กรุงเทพมหานคร",
            "zipcode": "10120",
            "id": 6,
            "createdAt": "2020-11-27T08:45:22.262Z",
            "updatedAt": "2021-01-06T05:31:35.066Z",
            "__v": 0
        },
        "logoPath": {
            "type": "image",
            "path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
            "id": 1410
        },
        "coverPath": {
            "type": "image",
            "path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
            "id": 1485
        }
    },
    "productSkus": [{
        "productId": 34,
        "imagePathId": 709,
        "priceList": 480,
        "priceNet": 240,
        "priceCost": 192,
        "stockRemain": 977,
        "status": "show",
        "statusStock": "instock",
        "showOn": ["shelf", "live"],
        "sku": "34-90 ml",
        "id": 93,
        "imagePath": {
            "type": "image",
            "path": "image/003a8f72-281e-40cc-899f-bcaa8ffa3e4e.jpg",
            "id": 709
        },
        "productDiscount": [],
        "attributeSKU": "90 ml",
        "select": true,
        "extraPrice": {
            "discountPrice": 216.6,
            "discountPercent": 5,
            "buyLimit": 3,
            "privileges": 4
        },
        "errors": {},
        "itemId": 1486
    }],
    "priceNet": 240,
    "priceTotal": 480
}, {
    "categories": ["health&beauty"],
    "productType": "general",
    "description": [{
        "contentType": "text",
        "content": "<p>โลชั่นปกป้องแสงแดด เป็นสูตร Provides broad spectrum UVA /UVB มากกว่า 50 เท่า<strong><u>โดยลดปริมาณสารเคมีลงถึง 25% </u></strong>ด้วยสูตรอ่อนโยนและบอบบางที่สุด <strong>ไม่มีส่วนผสม Oxybenzone &amp; Parabens ,&nbsp;Alcohol &amp; Oil, Microplsatic </strong>เนื้อโลชั่นเบาดุจน้ำสบายผิวไม่มันวาว , ทาผิวได้อย่างราบรื่น , เหมาะสำหรับผิวหน้าและผิวกาย , มีกลิ่นหอมประดุจดอกไม้ , <strong>มีส่วนผสมของ Hyaluronic Acid</strong></p>"
    }],
    "nameEn": null,
    "advancePay": null,
    "imagePathIds": [717],
    "videoPathIds": [],
    "tags": [],
    "seo": {
        "title": "กันแดดสูตรอ่อนโยน ดีต่อผิวหน้าและผิวกาย โนหน้าไม่มันวาว ไม่มีซับ ",
        "description": "โลชั่นปกป้องแสงแดด เป็นสูตร Provides broad spectrum UVA /UVB มากกว่า 50 เท่าโดยลดปริมาณสารเคมีลงถึง 25% ด้วยสูตรอ่อนโยนและบอบบางที่สุด ไม่มีส่วนผสม Oxybenzone & Parabens ,  Alcohol & Oil, Microplsatic มีส่วนผสมของ Hyaluronic Acid ",
        "keyword": ["โลชั่นกันแดด", "Banana Boat", " SPF50+ PA++++", " กันแดดสูตรอ่อนโยน ", "Hyaluronic Acid"],
        "seoImage": {
            "type": "image",
            "path": "image/dc90f672-457c-4081-a6cc-1359590e1c5e.jpg",
            "id": 718
        },
        "seoLength": {
            "title": "bad",
            "description": "bad",
            "keyword": "good"
        },
        "permalink": "simply-protect-aqua-daily-sunscreen-lotion-spf50+-pa++++",
        "seoImageId": 718
    },
    "unitType": "ชิ้น",
    "solds": 11,
    "remains": 989,
    "reserve": 0,
    "specifications": [],
    "skus": 1,
    "ribbon": [],
    "status": "show",
    "brand": "Banana Boat",
    "showOn": ["live", "shelf"],
    "platforms": ["callcenter", "web", "application"],
    "deleted": 0,
    "seoUpdatedAt": "2021-02-03T11:36:32.000Z",
    "freeShipping": 0,
    "conditionType": "new",
    "deliveryRules": 72,
    "prepareDay": 24,
    "shopId": 7,
    "saleType": "buynow",
    "name": "Banana Boat Simply Protect Aqua Daily Sunscreen Lotion SPF50+ PA++++ 50 ml. / บานาน่า โบ้ท ซิมพลี่ โพรเทค อควา เดลี่ ซันสกรีน เอสพีเอฟ50+ พีเอ++++ 50 มล. สูตรอ่อนโยน ดีต่อผิวหน้าและผิวกาย โนหน้าไม่มันวาว ไม่มีซับ",
    "coverPathId": 717,
    "createdBy": 50,
    "id": 35,
    "createdAt": "2020-11-28T10:53:55.780Z",
    "updatedAt": "2021-02-19T03:20:31.232Z",
    "__v": 0,
    "productCode": "35",
    "videoPath": [],
    "coverPath": {
        "type": "image",
        "path": "image/1555a330-d39f-4001-9acf-f2f949679c0f.jpg",
        "id": 717
    },
    "imagePath": [{
        "type": "image",
        "path": "image/1555a330-d39f-4001-9acf-f2f949679c0f.jpg",
        "id": 717
    }],
    "shop": {
        "logoPathId": 1410,
        "coverPathId": 1485,
        "imagePathIds": [],
        "videoPathIds": [],
        "name": "Banana Boat",
        "id": 7,
        "imagePath": [],
        "videoPath": [],
        "shopHub": {
            "address1": "467/11 โครงการมหาทุนพระราม 3",
            "address2": null,
            "location": {
                "lat": 13.689691,
                "lng": 100.512098
            },
            "primary": 0,
            "status": "show",
            "deleted": 0,
            "shopId": 7,
            "name": "Banana Boat",
            "mobile": "026891560",
            "subdistrict": "บางโคล่",
            "district": "บางคอแหลม",
            "province": "กรุงเทพมหานคร",
            "zipcode": "10120",
            "id": 6,
            "createdAt": "2020-11-27T08:45:22.262Z",
            "updatedAt": "2021-01-06T05:31:35.066Z",
            "__v": 0
        },
        "logoPath": {
            "type": "image",
            "path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
            "id": 1410
        },
        "coverPath": {
            "type": "image",
            "path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
            "id": 1485
        }
    },
    "productSkus": [{
        "productId": 35,
        "imagePathId": 719,
        "priceList": 390,
        "priceNet": 195,
        "priceCost": 156,
        "stockRemain": 989,
        "status": "show",
        "statusStock": "instock",
        "showOn": ["shelf", "live"],
        "sku": "35-50 ml",
        "id": 94,
        "imagePath": {
            "type": "image",
            "path": "image/81357635-7455-43af-a8a0-8983ff579068.jpg",
            "id": 719
        },
        "productDiscount": [],
        "attributeSKU": "50 ml",
        "select": false,
        "extraPrice": {
            "discountPrice": null,
            "discountPercent": null,
            "buyLimit": null,
            "privileges": null
        },
        "errors": {}
    }],
    "priceNet": 195,
    "priceTotal": 390
}, {
    "categories": ["health&beauty"],
    "productType": "general",
    "description": [{
        "contentType": "text",
        "content": "<p>โลชั่นปกป้องแสงแดด เป็นสูตร Provides broad spectrum UVA /UVB มากกว่า 50 เท่าโดย <strong><u>ลดปริมาณสารเคมีลงถึง 25%</u></strong> ด้วยสูตรอ่อนโยนและบอบบางที่สุด <strong>ไม่มีส่วนผสม Oxybenzone &amp; Parabens ,&nbsp;Alcohol &amp; Oil กันน้ำกันเหงื่อ,</strong> เหมาะสำหรับผิวหน้าและผิวกาย , <strong>ปกป้องสำหรับกีฬาและกิจกรรมกลางแจ้ง</strong> , มีกลิ่นหอมอ่อนๆ มีส่วนผสมของ Hyaluronic Acid</p>"
    }],
    "nameEn": null,
    "advancePay": null,
    "imagePathIds": [725],
    "videoPathIds": [],
    "tags": [],
    "seo": {
        "title": "โลชั่นกันแดดสูตรอ่อนโยน  กัน UVA /UVB มากกว่า 50 เท่า ",
        "description": "Simply Aqua Long Wearing Sunscreen Lotion SPF 50+ PA++++ โลชั่นปกป้องแสงแดด เป็นสูตร Provides broad spectrum UVA /UVB มากกว่า 50 เท่า โดยลดปริมาณสารเคมีลงถึง 25% ด้วยสูตรอ่อนโยนและบอบบางที่สุด",
        "keyword": ["โลชั่นกันแดด", "Banana Boat", "กันแดดผิวแพ้ง่าย", " UVA /UVB มากกว่า 50 เท่า", "SPF 50+ PA++++ "],
        "seoImage": {
            "type": "image",
            "path": "image/36a52f3e-2199-44b5-a7ae-1d1ec0843dd4.jpg",
            "id": 726
        },
        "seoLength": {
            "title": "bad",
            "description": "bad",
            "keyword": "good"
        },
        "permalink": "simply-aqua-long-wearing-sunscreen-lotion-spf-50+-pa++++",
        "seoImageId": 726
    },
    "unitType": "ชิ้น",
    "solds": 44,
    "remains": 959,
    "reserve": -3,
    "specifications": [],
    "skus": 1,
    "ribbon": [],
    "status": "show",
    "brand": "Banana Boat",
    "showOn": ["normal", "shelf", "live"],
    "platforms": ["callcenter", "web", "application"],
    "deleted": 0,
    "seoUpdatedAt": "2020-12-16T10:54:04.000Z",
    "freeShipping": 0,
    "conditionType": "new",
    "deliveryRules": 72,
    "prepareDay": 24,
    "shopId": 7,
    "saleType": "buynow",
    "name": "🌞 Banana Boat Simply Aqua Long Wearing Sunscreen Lotion SPF 50+ PA++++",
    "coverPathId": 725,
    "createdBy": 50,
    "id": 36,
    "createdAt": "2020-11-28T11:10:17.931Z",
    "updatedAt": "2021-02-18T11:49:50.883Z",
    "__v": 0,
    "productCode": "36",
    "videoPath": [],
    "coverPath": {
        "type": "image",
        "path": "image/e8ebdd91-f7bc-4cf5-a1f2-df63b6632762.jpg",
        "id": 725
    },
    "imagePath": [{
        "type": "image",
        "path": "image/e8ebdd91-f7bc-4cf5-a1f2-df63b6632762.jpg",
        "id": 725
    }],
    "shop": {
        "logoPathId": 1410,
        "coverPathId": 1485,
        "imagePathIds": [],
        "videoPathIds": [],
        "name": "Banana Boat",
        "id": 7,
        "imagePath": [],
        "videoPath": [],
        "shopHub": {
            "address1": "467/11 โครงการมหาทุนพระราม 3",
            "address2": null,
            "location": {
                "lat": 13.689691,
                "lng": 100.512098
            },
            "primary": 0,
            "status": "show",
            "deleted": 0,
            "shopId": 7,
            "name": "Banana Boat",
            "mobile": "026891560",
            "subdistrict": "บางโคล่",
            "district": "บางคอแหลม",
            "province": "กรุงเทพมหานคร",
            "zipcode": "10120",
            "id": 6,
            "createdAt": "2020-11-27T08:45:22.262Z",
            "updatedAt": "2021-01-06T05:31:35.066Z",
            "__v": 0
        },
        "logoPath": {
            "type": "image",
            "path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
            "id": 1410
        },
        "coverPath": {
            "type": "image",
            "path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
            "id": 1485
        }
    },
    "productSkus": [{
        "productId": 36,
        "imagePathId": 727,
        "priceList": 390,
        "priceNet": 195,
        "priceCost": 156,
        "stockRemain": 959,
        "status": "show",
        "statusStock": "instock",
        "showOn": ["normal", "shelf", "live"],
        "sku": "36-50 ml",
        "id": 95,
        "imagePath": {
            "type": "image",
            "path": "image/3d62c79d-5052-4026-b29e-fedb284a4560.jpg",
            "id": 727
        },
        "productDiscount": [],
        "attributeSKU": "50 ml",
        "select": true,
        "extraPrice": {
            "discountPrice": 175.75,
            "discountPercent": 5,
            "buyLimit": 5,
            "privileges": 4
        },
        "errors": {},
        "itemId": 1487
    }],
    "priceNet": 195,
    "priceTotal": 390
}, {
    "categories": ["health&beauty"],
    "productType": "general",
    "description": [{
        "contentType": "text",
        "content": "<p>- <strong>ผลิตภัณฑ์เจลบำรุงผิว (แบบขวด</strong>) ช่วยบำรุงผิวให้เนียนนุ่มชุ่มชื้น และยังช่วย<strong>บรรเทาอาการผิวไหม้จากแสงแดด</strong> สำหรับผู้ที่ตากแดดเป็นเวลานาน <strong>อุดมไปด้วยสารสกัดจากว่านหางจระเข้ </strong>ทำให้ผิวรู้สึกเย็นสบายเรียบเนียนยิ่งขึ้น</p><p><br></p><p><strong>- ผลิตภัณฑ์เจลบำรุงผิว (แบบหลอด)</strong> ช่วยบำรุงผิวให้เนียนนุ่มชุ่มชื้น และยังช่วย<strong>บรรเทาอาการผิวไหม้จากแสงแดด </strong>สำหรับผู้ที่ตากแดดเป็นเวลานาน <strong>อุดมไปด้วยสารสกัดจากว่านหางจระเข้ </strong>ทำให้ผิวรู้สึกเย็นสบายเรียบเนียนยิ่งขึ้น</p>"
    }],
    "nameEn": null,
    "advancePay": null,
    "imagePathIds": [732, 733],
    "videoPathIds": [],
    "tags": [],
    "seo": {
        "title": "ผิวไหม้ จากแสงแดด  Aloe Vera Gel ช่วยคุณได้ ผิว Happy ไม่มีเศร้า",
        "description": "ผลิตภัณฑ์เจลบำรุงผิว (แบบขวด) ช่วยบำรุงผิวให้เนียนนุ่มชุ่มชื้น และยังช่วยบรรเทาอาการผิวไหม้จากแสงแดด สำหรับผู้ที่ตากแดดเป็นเวลานาน อุดมไปด้วยสารสกัดจากว่านหางจระเข้ ทำให้ผิวรู้สึกเย็นสบายเรียบเนียนยิ่งขึ้น ",
        "keyword": ["Banana Boat ", "Aloe Vera Gel", " ผิวไหม้จากแสงแดด ", "ผลิตภัณฑ์ว่านหางจระเข้"],
        "seoImage": {
            "type": "image",
            "path": "image/ed19dfd4-3c17-4de0-9dd7-249ce66e6b92.jpg",
            "id": 734
        },
        "seoLength": {
            "title": "bad",
            "description": "bad",
            "keyword": "bad"
        },
        "permalink": "aloe-vera-gel",
        "seoImageId": 734
    },
    "unitType": "ชิ้น",
    "solds": 38,
    "remains": 1962,
    "reserve": 0,
    "specifications": [],
    "skus": 1,
    "ribbon": [],
    "status": "show",
    "brand": "Banana Boat",
    "showOn": ["live", "shelf", "normal"],
    "platforms": ["callcenter", "web", "application"],
    "deleted": 0,
    "seoUpdatedAt": "2021-01-19T07:13:38.000Z",
    "freeShipping": 0,
    "conditionType": "new",
    "deliveryRules": 72,
    "prepareDay": 24,
    "shopId": 7,
    "saleType": "buynow",
    "name": "🌞 Banana Boat Aloe Vera Gel ",
    "coverPathId": 732,
    "createdBy": 50,
    "id": 37,
    "createdAt": "2020-11-28T11:19:53.590Z",
    "updatedAt": "2021-02-18T08:52:30.727Z",
    "__v": 0,
    "productCode": "37",
    "videoPath": [],
    "coverPath": {
        "type": "image",
        "path": "image/965ac02a-c5ef-43fd-a1fd-e1cc8be6cbbb.jpg",
        "id": 732
    },
    "imagePath": [{
        "type": "image",
        "path": "image/965ac02a-c5ef-43fd-a1fd-e1cc8be6cbbb.jpg",
        "id": 732
    }, {
        "type": "image",
        "path": "image/7757560c-5784-44ab-af6c-0003bf34ad34.jpg",
        "id": 733
    }],
    "shop": {
        "logoPathId": 1410,
        "coverPathId": 1485,
        "imagePathIds": [],
        "videoPathIds": [],
        "name": "Banana Boat",
        "id": 7,
        "imagePath": [],
        "videoPath": [],
        "shopHub": {
            "address1": "467/11 โครงการมหาทุนพระราม 3",
            "address2": null,
            "location": {
                "lat": 13.689691,
                "lng": 100.512098
            },
            "primary": 0,
            "status": "show",
            "deleted": 0,
            "shopId": 7,
            "name": "Banana Boat",
            "mobile": "026891560",
            "subdistrict": "บางโคล่",
            "district": "บางคอแหลม",
            "province": "กรุงเทพมหานคร",
            "zipcode": "10120",
            "id": 6,
            "createdAt": "2020-11-27T08:45:22.262Z",
            "updatedAt": "2021-01-06T05:31:35.066Z",
            "__v": 0
        },
        "logoPath": {
            "type": "image",
            "path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
            "id": 1410
        },
        "coverPath": {
            "type": "image",
            "path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
            "id": 1485
        }
    },
    "productSkus": [{
        "productId": 37,
        "imagePathId": 736,
        "priceList": 150,
        "priceNet": 75,
        "priceCost": 60,
        "stockRemain": 970,
        "status": "show",
        "statusStock": "instock",
        "showOn": ["normal", "shelf", "live"],
        "sku": "37-หลอด",
        "id": 191,
        "imagePath": {
            "type": "image",
            "path": "image/f60bd6a8-73ee-462d-865e-f74ca22ae2d4.jpg",
            "id": 736
        },
        "productDiscount": [],
        "attributeSKU": "หลอด",
        "select": false,
        "extraPrice": {
            "discountPrice": null,
            "discountPercent": null,
            "buyLimit": null,
            "privileges": null
        },
        "errors": {}
    }, {
        "productId": 37,
        "imagePathId": 1134,
        "priceList": 340,
        "priceNet": 170,
        "priceCost": 136,
        "stockRemain": 992,
        "status": "show",
        "statusStock": "instock",
        "showOn": ["normal", "shelf", "live"],
        "sku": "37-ขวด",
        "id": 285,
        "imagePath": {
            "type": "image",
            "path": "image/e3bb7bb8-f60f-42d3-8857-66bfb87c89e2.jfif",
            "id": 1134
        },
        "productDiscount": [],
        "attributeSKU": "ขวด",
        "select": false,
        "extraPrice": {
            "discountPrice": null,
            "discountPercent": null,
            "buyLimit": null,
            "privileges": null
        },
        "errors": {}
    }],
    "priceNet": 75,
    "priceTotal": 150
}, {
    "categories": ["health&beauty"],
    "productType": "general",
    "description": [{
        "contentType": "text",
        "content": "<p>สเปรย์กันแดดสำหรับปกป้องผิวใช้ได้ทุกวันเนื้อสเปรย์ซึมซาบเร็วไม่อุดตันรูขุมขน มีส่วนผสมของว่านหางจระเข้และวิตามินอีช่วยให้ผิวเนียนนุ่มชุ่มชื้นเย็นสดชื่นสบายผิว <strong><u>พร้อมช่วยปกป้องผิวจากการเผาไหม้ของแสงแดดถึง 50 เท่า</u></strong> พร้อมปกป้องทั้งรังสียูวีเอและยูวีบีซึ่งเป็นสาเหตุของริ้วรอยและมะเร็งผิวหนัง กันแดดได้ยาวนานและกันน้ำได้ดีเยี่ยม</p>"
    }],
    "nameEn": null,
    "advancePay": null,
    "imagePathIds": [746],
    "videoPathIds": [],
    "tags": [],
    "seo": {
        "title": "สเปรย์กันแดด  พกสะดวกใช้ง่าย แค่ฉีด เอาแดดอยู่หมัด ",
        "description": "สเปรย์กันแดดสำหรับปกป้องผิวใช้ได้ทุกวันเนื้อสเปรย์ซึมซาบเร็วไม่อุดตันรูขุมขน มีส่วนผสมของว่านหางจระเข้และวิตามินอีช่วยให้ผิวเนียนนุ่มชุ่มชื้นเย็นสดชื่นสบายผิวพร้อมช่วยปกป้องผิวจากการเผาไหม้ของแสงแดดถึง 50 เท่า",
        "keyword": ["Banana Boat", "สเปรย์กันแดด", "สเปรย์กันแดดกันน้ำ"],
        "seoImage": {
            "type": "image",
            "path": "image/acaf531a-1114-4583-8fb3-97f0a0424095.jpg",
            "id": 747
        },
        "seoLength": {
            "title": "bad",
            "description": "bad",
            "keyword": "good"
        },
        "permalink": "ultramist-ultra-protect-sunscreen-lotion-spf-50-pa+++",
        "seoImageId": 747
    },
    "unitType": "ชิ้น",
    "solds": 36,
    "remains": 973,
    "reserve": -9,
    "specifications": [],
    "skus": 1,
    "ribbon": [],
    "status": "show",
    "brand": "Banana Boat",
    "showOn": ["normal", "shelf", "live"],
    "platforms": ["callcenter", "web", "application"],
    "deleted": 0,
    "seoUpdatedAt": "2020-12-21T07:55:42.000Z",
    "freeShipping": 0,
    "conditionType": "new",
    "deliveryRules": 72,
    "prepareDay": 24,
    "shopId": 7,
    "saleType": "buynow",
    "name": "🌞 Banana Boat UltraMist Ultra Protect Sunscreen Lotion SPF 50 PA+++",
    "coverPathId": 746,
    "createdBy": 50,
    "id": 39,
    "createdAt": "2020-11-28T11:44:04.884Z",
    "updatedAt": "2021-02-18T08:45:27.371Z",
    "__v": 0,
    "productCode": "39",
    "videoPath": [],
    "coverPath": {
        "type": "image",
        "path": "image/e625b5d9-4f6b-424e-b637-a59275aad996.jpg",
        "id": 746
    },
    "imagePath": [{
        "type": "image",
        "path": "image/e625b5d9-4f6b-424e-b637-a59275aad996.jpg",
        "id": 746
    }],
    "shop": {
        "logoPathId": 1410,
        "coverPathId": 1485,
        "imagePathIds": [],
        "videoPathIds": [],
        "name": "Banana Boat",
        "id": 7,
        "imagePath": [],
        "videoPath": [],
        "shopHub": {
            "address1": "467/11 โครงการมหาทุนพระราม 3",
            "address2": null,
            "location": {
                "lat": 13.689691,
                "lng": 100.512098
            },
            "primary": 0,
            "status": "show",
            "deleted": 0,
            "shopId": 7,
            "name": "Banana Boat",
            "mobile": "026891560",
            "subdistrict": "บางโคล่",
            "district": "บางคอแหลม",
            "province": "กรุงเทพมหานคร",
            "zipcode": "10120",
            "id": 6,
            "createdAt": "2020-11-27T08:45:22.262Z",
            "updatedAt": "2021-01-06T05:31:35.066Z",
            "__v": 0
        },
        "logoPath": {
            "type": "image",
            "path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
            "id": 1410
        },
        "coverPath": {
            "type": "image",
            "path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
            "id": 1485
        }
    },
    "productSkus": [{
        "productId": 39,
        "imagePathId": 749,
        "priceList": 720,
        "priceNet": 360,
        "priceCost": 288,
        "stockRemain": 973,
        "status": "show",
        "statusStock": "instock",
        "showOn": ["normal", "shelf", "live"],
        "sku": "39-175 ml",
        "id": 98,
        "imagePath": {
            "type": "image",
            "path": "image/0e7bd6a3-9861-48ec-b822-7d816edac017.jpg",
            "id": 749
        },
        "productDiscount": [],
        "attributeSKU": "175 ml",
        "select": false,
        "extraPrice": {
            "discountPrice": null,
            "discountPercent": null,
            "buyLimit": null,
            "privileges": null
        },
        "errors": {}
    }],
    "priceNet": 360,
    "priceTotal": 720
}, {
    "categories": ["health&beauty"],
    "productType": "general",
    "description": [{
        "contentType": "text",
        "content": "<p><strong>สเปรย์กันแดดสำหรับเล่นกีฬาที่ทำให้ผิวสัมผัสความเย็นยาวนาน</strong> เพื่อความรู้สึกสะอาดสดชื่น ปกป้องผิวจากการเผาไหม้ของแสงแดดมากกว่า 50 เท่า พร้อมปกป้องทั้งรังสียูวีเอและยูวีบีซึ่งเป็นสาเหตุของริ้วรอยและมะเร็งผิวหนัง<strong> กันแดดได้ยาวนานและกันน้ำได้ดีเยี่ยม</strong></p>"
    }],
    "nameEn": null,
    "advancePay": null,
    "imagePathIds": [754],
    "videoPathIds": [],
    "tags": [],
    "seo": {
        "title": "เล่นกีฬาสู้แดด! ใช้สเปรย์กันแดด แค่ฉีดผิวเย็นยาว กันน้ำได้ดี ",
        "description": "สเปรย์กันแดดสำหรับเล่นกีฬาที่ทำให้ผิวสัมผัสความเย็นยาวนาน เพื่อความรู้สึกสะอาดสดชื่น ปกป้องผิวจากการเผาไหม้ของแสงแดดมากกว่า 50 เท่า พร้อมปกป้องทั้งรังสียูวีเอและยูวีบีซึ่งเป็นสาเหตุของริ้วรอยและมะเร็งผิวหนัง กันแดดได้ยาวนานและกันน้ำได้ดีเยี่ยม",
        "keyword": ["Banana Boat", "สเปรย์กันแดด", "สเปรย์กันแดดสูตรเย็น", "กันแดดสำหรับเล่นกีฬา", "สเปรย์ฉีดผิว"],
        "seoImage": {
            "type": "image",
            "path": "image/d9e6daeb-f2ad-4ff8-9585-8a8e99464b36.jpg",
            "id": 756
        },
        "seoLength": {
            "title": "bad",
            "description": "bad",
            "keyword": "bad"
        },
        "permalink": "ultramist-sport-coolzone-sunscreen-lotion-spf-50+-pa+++",
        "seoImageId": 756
    },
    "unitType": "ชิ้น",
    "solds": 22,
    "remains": 978,
    "reserve": 0,
    "specifications": [],
    "skus": 1,
    "ribbon": [],
    "status": "show",
    "brand": "Banana Boat",
    "showOn": ["normal", "shelf", "live"],
    "platforms": ["callcenter", "web", "application"],
    "deleted": 0,
    "seoUpdatedAt": "2020-12-23T04:25:41.000Z",
    "freeShipping": 0,
    "conditionType": "new",
    "deliveryRules": 72,
    "prepareDay": 24,
    "shopId": 7,
    "saleType": "buynow",
    "name": "🌞 Banana Boat UltraMist Sport Coolzone Sunscreen Lotion SPF 50+ PA+++",
    "coverPathId": 754,
    "createdBy": 50,
    "id": 40,
    "createdAt": "2020-11-28T11:59:48.697Z",
    "updatedAt": "2021-02-18T11:49:26.021Z",
    "__v": 0,
    "productCode": "40",
    "videoPath": [],
    "coverPath": {
        "type": "image",
        "path": "image/221268ed-2027-4b29-901c-ee84dc0ef60e.jpg",
        "id": 754
    },
    "imagePath": [{
        "type": "image",
        "path": "image/221268ed-2027-4b29-901c-ee84dc0ef60e.jpg",
        "id": 754
    }],
    "shop": {
        "logoPathId": 1410,
        "coverPathId": 1485,
        "imagePathIds": [],
        "videoPathIds": [],
        "name": "Banana Boat",
        "id": 7,
        "imagePath": [],
        "videoPath": [],
        "shopHub": {
            "address1": "467/11 โครงการมหาทุนพระราม 3",
            "address2": null,
            "location": {
                "lat": 13.689691,
                "lng": 100.512098
            },
            "primary": 0,
            "status": "show",
            "deleted": 0,
            "shopId": 7,
            "name": "Banana Boat",
            "mobile": "026891560",
            "subdistrict": "บางโคล่",
            "district": "บางคอแหลม",
            "province": "กรุงเทพมหานคร",
            "zipcode": "10120",
            "id": 6,
            "createdAt": "2020-11-27T08:45:22.262Z",
            "updatedAt": "2021-01-06T05:31:35.066Z",
            "__v": 0
        },
        "logoPath": {
            "type": "image",
            "path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
            "id": 1410
        },
        "coverPath": {
            "type": "image",
            "path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
            "id": 1485
        }
    },
    "productSkus": [{
        "productId": 40,
        "imagePathId": 757,
        "priceList": 720,
        "priceNet": 360,
        "priceCost": 288,
        "stockRemain": 978,
        "status": "show",
        "statusStock": "instock",
        "showOn": ["normal", "shelf", "live"],
        "sku": "40-170 g",
        "id": 192,
        "imagePath": {
            "type": "image",
            "path": "image/ca5e00a2-74fa-4642-a6f7-df10822c3a77.jpg",
            "id": 757
        },
        "productDiscount": [],
        "attributeSKU": "170 g",
        "select": false,
        "extraPrice": {
            "discountPrice": null,
            "discountPercent": null,
            "buyLimit": null,
            "privileges": null
        },
        "errors": {}
    }],
    "priceNet": 360,
    "priceTotal": 720
}, {
    "categories": ["health&beauty"],
    "productType": "general",
    "description": [{
        "contentType": "text",
        "content": "<p>สเปรย์ป้องกันแสงแดดปกป้องผิวได้อย่างมีประสิทธิภาพด้วยค่า SPF ที่สูงถึง 50+ เนื้อเสปรย์บางเบาไม่เหนียวเหนอะหนะกันน้ำและหยาดเหงื่อได้เป็นอย่างดีและยังมี <strong>ส่วนผสมของ Moisture , Vitamin C , Vitamin E และ Aloe Vera</strong> เพื่อช่วยลดอาการผิวไหม้/แห้งและสามารถบำรุงผิวให้ผิวกลับมาเนียนนุ่มชุ่มชื้นหลังออกแดด</p>"
    }],
    "nameEn": null,
    "advancePay": null,
    "imagePathIds": [761],
    "videoPathIds": [],
    "tags": [],
    "seo": {
        "title": "สเปรย์กันแดด SPF สูงถึง 50+ กันน้ำ กันเหงื่อ ออกแดดหมดกังวล",
        "description": "สเปรย์ป้องกันแสงแดดปกป้องผิวได้อย่างมีประสิทธิภาพด้วยค่า SPF ที่สูงถึง 50+ เนื้อเสปรย์บางเบาไม่เหนียวเหนอะหนะกันน้ำและหยาดเหงื่อได้เป็นอย่างดีและยังมี ส่วนผสมของ Moisture , Vitamin C , Vitamin E และ Aloe Vera เพื่อช่วยลดอาการผิวไหม้/แห้งและสามารถบำรุงผิวให้ผิวกลับมาเนียนนุ่มชุ่มชื้นหลังออกแดด",
        "keyword": ["Banana Boat ", "สเปรย์กันแดด", "SPF  50+", "สเปรย์กันแดดกันน้ำ "],
        "seoImage": {
            "type": "image",
            "path": "image/70ff7cc5-3039-4267-8c65-ed296a6992b2.jpg",
            "id": 762
        },
        "seoLength": {
            "title": "bad",
            "description": "bad",
            "keyword": "good"
        },
        "permalink": "clearสเปรย์กันแดด-spf-สูงถึง-50+-กันน้ำ-กันเหงื่อ-ออกแดดหมดกังวล",
        "seoImageId": 762
    },
    "unitType": "ชิ้น",
    "solds": 3,
    "remains": 998,
    "reserve": -1,
    "specifications": [],
    "skus": 1,
    "ribbon": [],
    "status": "show",
    "brand": "Banana Boat",
    "showOn": ["live", "shelf", "normal"],
    "platforms": ["callcenter", "web", "application"],
    "deleted": 0,
    "seoUpdatedAt": "2021-01-20T07:01:45.000Z",
    "freeShipping": 0,
    "conditionType": "new",
    "deliveryRules": 72,
    "prepareDay": 24,
    "shopId": 7,
    "saleType": "buynow",
    "name": "🌞 Banana Boat Clear Ultra Mist Protect & Hydrate SPF 50+ PA+++",
    "coverPathId": 761,
    "createdBy": 50,
    "id": 41,
    "createdAt": "2020-11-28T12:16:33.625Z",
    "updatedAt": "2021-02-16T11:44:20.527Z",
    "__v": 0,
    "productCode": "41",
    "videoPath": [],
    "coverPath": {
        "type": "image",
        "path": "image/f5e4607c-6d33-4406-849c-aee448e993ab.jpg",
        "id": 761
    },
    "imagePath": [{
        "type": "image",
        "path": "image/f5e4607c-6d33-4406-849c-aee448e993ab.jpg",
        "id": 761
    }],
    "shop": {
        "logoPathId": 1410,
        "coverPathId": 1485,
        "imagePathIds": [],
        "videoPathIds": [],
        "name": "Banana Boat",
        "id": 7,
        "imagePath": [],
        "videoPath": [],
        "shopHub": {
            "address1": "467/11 โครงการมหาทุนพระราม 3",
            "address2": null,
            "location": {
                "lat": 13.689691,
                "lng": 100.512098
            },
            "primary": 0,
            "status": "show",
            "deleted": 0,
            "shopId": 7,
            "name": "Banana Boat",
            "mobile": "026891560",
            "subdistrict": "บางโคล่",
            "district": "บางคอแหลม",
            "province": "กรุงเทพมหานคร",
            "zipcode": "10120",
            "id": 6,
            "createdAt": "2020-11-27T08:45:22.262Z",
            "updatedAt": "2021-01-06T05:31:35.066Z",
            "__v": 0
        },
        "logoPath": {
            "type": "image",
            "path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
            "id": 1410
        },
        "coverPath": {
            "type": "image",
            "path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
            "id": 1485
        }
    },
    "productSkus": [{
        "productId": 41,
        "imagePathId": 767,
        "priceList": 790,
        "priceNet": 395,
        "priceCost": 316,
        "stockRemain": 998,
        "status": "show",
        "statusStock": "instock",
        "showOn": ["normal", "shelf", "live"],
        "sku": "41-170 g",
        "id": 193,
        "imagePath": {
            "type": "image",
            "path": "image/1617848d-d29f-4b8b-a36a-11203326c00a.jpg",
            "id": 767
        },
        "productDiscount": [],
        "attributeSKU": "170 g",
        "select": false,
        "extraPrice": {
            "discountPrice": null,
            "discountPercent": null,
            "buyLimit": null,
            "privileges": null
        },
        "errors": {}
    }],
    "priceNet": 395,
    "priceTotal": 790
}, {
    "categories": ["health&beauty"],
    "productType": "general",
    "description": [{
        "contentType": "text",
        "content": "<p>ผลิตภัณฑ์บำรุงผิวผสมสารป้องกันแดดและทำผิวเป็นสีแทนธรรมชาติ มีส่วนผสมของสารสกัดจากแครอทและกล้วย ช่วยบำรุงให้ผิวเนียนนุ่ม ชุ่มชื่น และทำให้ผิวเป็นสีแทนทองได้นานอย่างธรรมชาติ พร้อมช่วย <strong>ปกป้องผิวจากการเผาไหม้ของแสงแดดถึง 8 เท่า</strong></p>"
    }],
    "nameEn": null,
    "advancePay": null,
    "imagePathIds": [774],
    "videoPathIds": [],
    "tags": [],
    "seo": {
        "title": "Protective Tanning Oil SPF 8 บำรุงผิวด้วยสารสกัดจากธรรมชาติ",
        "description": "ผลิตภัณฑ์บำรุงผิวผสมสารป้องกันแดดและทำผิวเป็นสีแทนธรรมชาติ มีส่วนผสมของสารสกัดจากแครอทและกล้วย ช่วยบำรุงให้ผิวเนียนนุ่ม ชุ่มชื่น และทำให้ผิวเป็นสีแทนทองได้นานอย่างธรรมชาติ พร้อมช่วย ปกป้องผิวจากการเผาไหม้ของแสงแดดถึง 8 เท่า",
        "keyword": ["Banana Boat", "ครีมกันแดด", " ผลิตภัณฑ์บำรุงผสมกันแดด"],
        "seoImage": {
            "type": "image",
            "path": "image/daba2c3e-ec8d-4de4-9f53-8044577130ba.jpg",
            "id": 776
        },
        "seoLength": {
            "title": "bad",
            "description": "bad",
            "keyword": "bad"
        },
        "permalink": "protective-tanning-oil-spf-8",
        "seoImageId": 776
    },
    "unitType": "ชิ้น",
    "solds": 13,
    "remains": 1985,
    "reserve": 2,
    "specifications": [],
    "skus": 1,
    "ribbon": [],
    "status": "show",
    "brand": "Banana Boat",
    "showOn": ["live", "shelf"],
    "platforms": ["callcenter", "web", "application"],
    "deleted": 0,
    "seoUpdatedAt": "2021-01-20T08:52:22.000Z",
    "freeShipping": 0,
    "conditionType": "new",
    "deliveryRules": 72,
    "prepareDay": 24,
    "shopId": 7,
    "saleType": "buynow",
    "name": "🌞 Banana Boat Protective Tanning Oil SPF 8",
    "coverPathId": 774,
    "createdBy": 50,
    "id": 42,
    "createdAt": "2020-11-28T12:29:15.507Z",
    "updatedAt": "2021-02-18T11:49:51.287Z",
    "__v": 0,
    "productCode": "42",
    "videoPath": [],
    "coverPath": {
        "type": "image",
        "path": "image/ac0170f9-57ad-4fe5-b765-30af58d06614.jpg",
        "id": 774
    },
    "imagePath": [{
        "type": "image",
        "path": "image/ac0170f9-57ad-4fe5-b765-30af58d06614.jpg",
        "id": 774
    }],
    "shop": {
        "logoPathId": 1410,
        "coverPathId": 1485,
        "imagePathIds": [],
        "videoPathIds": [],
        "name": "Banana Boat",
        "id": 7,
        "imagePath": [],
        "videoPath": [],
        "shopHub": {
            "address1": "467/11 โครงการมหาทุนพระราม 3",
            "address2": null,
            "location": {
                "lat": 13.689691,
                "lng": 100.512098
            },
            "primary": 0,
            "status": "show",
            "deleted": 0,
            "shopId": 7,
            "name": "Banana Boat",
            "mobile": "026891560",
            "subdistrict": "บางโคล่",
            "district": "บางคอแหลม",
            "province": "กรุงเทพมหานคร",
            "zipcode": "10120",
            "id": 6,
            "createdAt": "2020-11-27T08:45:22.262Z",
            "updatedAt": "2021-01-06T05:31:35.066Z",
            "__v": 0
        },
        "logoPath": {
            "type": "image",
            "path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
            "id": 1410
        },
        "coverPath": {
            "type": "image",
            "path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
            "id": 1485
        }
    },
    "productSkus": [{
        "productId": 42,
        "imagePathId": 777,
        "priceList": 500,
        "priceNet": 300,
        "priceCost": 196,
        "stockRemain": 995,
        "status": "show",
        "statusStock": "instock",
        "showOn": ["shelf", "live"],
        "sku": "42-236 ml",
        "id": 101,
        "imagePath": {
            "type": "image",
            "path": "image/bb0bf79a-cd79-493b-a399-c5e78ca32ce7.jpg",
            "id": 777
        },
        "productDiscount": [],
        "attributeSKU": "236 ml",
        "select": false,
        "extraPrice": {
            "discountPrice": null,
            "discountPercent": null,
            "buyLimit": null,
            "privileges": null
        },
        "errors": {}
    }, {
        "productId": 42,
        "imagePathId": 774,
        "priceList": 500,
        "priceNet": 100,
        "priceCost": 123,
        "stockRemain": 990,
        "status": "show",
        "statusStock": "instock",
        "showOn": ["shelf", "live"],
        "sku": "42-300",
        "id": 266,
        "imagePath": {
            "type": "image",
            "path": "image/ac0170f9-57ad-4fe5-b765-30af58d06614.jpg",
            "id": 774
        },
        "productDiscount": [],
        "attributeSKU": "300",
        "select": false,
        "extraPrice": {
            "discountPrice": null,
            "discountPercent": null,
            "buyLimit": null,
            "privileges": null
        },
        "errors": {}
    }],
    "priceNet": 100,
    "priceTotal": 500
}, {
    "categories": ["Babies & Kids"],
    "productType": "general",
    "description": [{
        "contentType": "text",
        "content": "<p>Nendoroid 1221 Yusuke Urameshi Yu Yu Hakusho ของแท้ 100%  ฟิกเกอร์ โมเดล GoodSmile</p><p><br></p><p>สินค้า: Nendoroid (เนนโดรอยด์)</p><p>วัสดุ : PAINTED ABS&amp;PVC with stand included</p><p>สเปค : NON Scale ประมาณ 10 ซม.</p><p>ผู้ผลิต: Good Smile Company</p><p><br></p><p>👉  สินค้าลิขสิทธิ์แท้  💯%   LOT JAPAN 🇯🇵 (ญี่ปุ่น)</p><p><br></p><p>👉  สินค้าทุกรายการพร้อมส่งคะ</p><p><br></p><p><br></p><p>*********************</p><p>📦 ลงทะเบียน 70บาท</p><p>📦 EMS 100บาท</p><p>*********************</p><p><br></p><p>📲 : 082-907-7207</p><p>Line id: @toyzelect  📌มี @ ด้วยนะคะ 📌</p><p>Facebook : https://www.facebook.com/ToyZelect/</p>"
    }],
    "nameEn": null,
    "advancePay": null,
    "imagePathIds": [1579, 1580],
    "videoPathIds": [],
    "tags": [],
    "seo": {
        "title": "Nendoroid 1221 Yusuke Urameshi Yu Yu Hakusho ของแท้ 100%",
        "description": "Nendoroid 1221 Yusuke Urameshi Yu Yu Hakusho ของแท้ 100%",
        "keyword": ["nendoroidl", "Nendoroid", "NendoroidThailand", "YusukeUrameshi"],
        "seoImage": {
            "type": "image",
            "path": "image/680ea7fd-7eb2-4dba-94df-703ac3ffbea5.jpeg",
            "id": 1579
        },
        "seoLength": {
            "title": "bad",
            "description": "bad",
            "keyword": "good"
        },
        "permalink": "Yusuke-nendoroid",
        "seoImageId": 1579
    },
    "unitType": "ชิ้น",
    "solds": 2,
    "remains": 2,
    "reserve": 0,
    "specifications": [],
    "skus": 1,
    "ribbon": [],
    "status": "show",
    "brand": "Good Smile",
    "showOn": ["live", "shelf", "normal"],
    "platforms": ["callcenter", "web", "application"],
    "deleted": 0,
    "seoUpdatedAt": "2021-02-10T09:33:04.000Z",
    "freeShipping": 0,
    "conditionType": "new",
    "deliveryRules": 72,
    "prepareDay": 24,
    "shopId": 7,
    "saleType": "buynow",
    "name": "Nendoroid 1221 Yusuke Urameshi Yu Yu Hakusho ของแท้ 100%  ฟิกเกอร์ โมเดล GoodSmile",
    "coverPathId": 1579,
    "createdBy": 50,
    "id": 195,
    "createdAt": "2021-02-10T09:33:05.013Z",
    "updatedAt": "2021-02-11T06:21:15.761Z",
    "__v": 0,
    "productCode": "195",
    "videoPath": [],
    "coverPath": {
        "type": "image",
        "path": "image/680ea7fd-7eb2-4dba-94df-703ac3ffbea5.jpeg",
        "id": 1579
    },
    "imagePath": [{
        "type": "image",
        "path": "image/680ea7fd-7eb2-4dba-94df-703ac3ffbea5.jpeg",
        "id": 1579
    }, {
        "type": "image",
        "path": "image/57486319-ad97-4f06-9656-210e7ea6a670.jpeg",
        "id": 1580
    }],
    "shop": {
        "logoPathId": 1410,
        "coverPathId": 1485,
        "imagePathIds": [],
        "videoPathIds": [],
        "name": "Banana Boat",
        "id": 7,
        "imagePath": [],
        "videoPath": [],
        "shopHub": {
            "address1": "467/11 โครงการมหาทุนพระราม 3",
            "address2": null,
            "location": {
                "lat": 13.689691,
                "lng": 100.512098
            },
            "primary": 0,
            "status": "show",
            "deleted": 0,
            "shopId": 7,
            "name": "Banana Boat",
            "mobile": "026891560",
            "subdistrict": "บางโคล่",
            "district": "บางคอแหลม",
            "province": "กรุงเทพมหานคร",
            "zipcode": "10120",
            "id": 6,
            "createdAt": "2020-11-27T08:45:22.262Z",
            "updatedAt": "2021-01-06T05:31:35.066Z",
            "__v": 0
        },
        "logoPath": {
            "type": "image",
            "path": "image/f7700dc8-794e-4188-b544-3a36cdb7a1f7.png",
            "id": 1410
        },
        "coverPath": {
            "type": "image",
            "path": "image/92468b32-5ef8-4ce9-a479-9739fc34fd9c.jfif",
            "id": 1485
        }
    },
    "productSkus": [{
        "productId": 195,
        "imagePathId": 1579,
        "priceList": 1800,
        "priceNet": 1600,
        "priceCost": 1400,
        "stockRemain": 2,
        "status": "show",
        "statusStock": "instock",
        "showOn": ["normal", "shelf", "live"],
        "sku": "195-md",
        "id": 405,
        "imagePath": {
            "type": "image",
            "path": "image/680ea7fd-7eb2-4dba-94df-703ac3ffbea5.jpeg",
            "id": 1579
        },
        "productDiscount": [],
        "attributeSKU": "md",
        "select": false,
        "extraPrice": {
            "discountPrice": null,
            "discountPercent": null,
            "buyLimit": null,
            "privileges": null
        },
        "errors": {}
    }],
    "priceNet": 1600,
    "priceTotal": 1800
}]